<template>
  <div class="flex-1 flex flex-col overflow-hidden mb-16">
    <loading :active="releaseType"
              :can-cancel="true"
              :on-cancel="onCancel"
              :is-full-page="true"
              :color="'#fff'"
              :background-color="'#000'"
              :opacity="'0.8'"
              :loader=" dots"
              :style="style">
              <!-- <div class="text-center text-blue-50 text-4xl" style="background-color:red;word-wrap:break-word; width:300px;">建立關鍵字...</div>
              <div class="w-2/4" style="background-color:blue;display: flex; justify-content: center; align-items: center; width:300px; ">
                <div style="margin: auto"> -->
                  <!-- <circle-progress :percent="releasePercent" :show-percent="true" :class="'text-blue-50 text-4xl'"/> -->
                  <div id="myItem5" class="ldBar label-center" data-type="fill" data-img="https://dev-private.autoturn.net/autoturn_logo_v04.svg" style="width:300px;height:300px;" ></div>
                <!-- </div>
              </div> -->
    </loading>
    <loading :active="!showCampaignData"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="true"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <Header :title="showLang[selectLang]['views']['EventBrowse']['page_name']" :editPage="cancelEdit" @childLang="useLang">
      <div class="mx-4 text-gray-700">
        {{showLang[selectLang]['views']['EventBrowse']['advertising_source']}}
      </div>
      <div class="grid grid-cols-4 border-2 rounded-md w-28 -ml-2" style="border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);">
        <img width="28" src="https://dev-private.autoturn.net/img/facebook_icon.png"/>
        <div class="mx-1 text-sm leading-7">
          Facebook
        </div>
      </div>
      <div class="mx-4 text-gray-700">
        {{showLang[selectLang]['views']['EventBrowse']['advertise_account_text']}}
      </div>
      <div class="mx-1 text-sm text-gray-400 leading-7 border-2 rounded-md px-1 -ml-2" style="border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);">
        {{ adaccount_name }}
      </div>
    </Header>
    <main class="flex overflow-x-hidden bg-gray-200">
      <div class="w-1/5 mx-auto p-4">
        <div class="w-full rounded-xl bg-white p-4" :style="{height: `520px`}">
          <div v-show="false" class="h-16">
            <span class="break-all">{{campaign_name}}</span>
          </div>
          <hr v-show="false" class="mb-4 border-b-1 border-blueGray-200">
          <div class="space-y-4 overflow-y-auto" :style="{height: `480px`}">
            <div v-for="(item, index) in menu" :key="index">
              <div
                v-if="item.show"
                :class="[
                  item.open? 'text-gray-700 p-1 h-8 -mb-6' : 'text-gray-300',
                  item.target === target? 'bg-gray-100 rounded-xl' : ''
                ]">
                <!-- <i class="pi pi-chevron-down"></i> -->
                <i class="pi pi-chevron-down block float-left mt-1.5"></i>
                <!-- <span class="mx-2">{{ item.title }}</span> -->
                <span class="mx-2 block float-left w-36 break-words">{{ item.title }}</span>
                <i class="pi pi-lock float-right" v-if="!item.open"></i>
              </div>
              <div class="space-y-2 ml-4 my-2 mt-7" v-if="item.open">
                <div
                  class="text-gray-700 cursor-pointer ml-1"
                  @click="getHere(item?.target, sub?.refName, sub?.groupType)"
                  v-for="(sub, idx) in item.submenu" :key="idx">
                  <span v-if="sub.show" class="mx-2 block w-40 break-words">{{ sub.title }}</span>
                  <i class="pi pi-check-circle float-right" v-if="sub.checked"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="edit_content" ref="scrollcontent" class="w-4/5 mx-auto p-4 overflow-y-auto">
        <div v-show="target == 1">
          <CampaignName ref="childCampaignName" v-bind:editPage="cancelEdit" v-model:viewDatalist="campaign_name" v-bind:lang="showLang[selectLang]" />
          <MarketingMethod ref="childMarketingMethod" v-bind:editPage="cancelEdit" v-model:viewDatalist="methodData" v-bind:goalsObjective="getGoalsObjective" v-bind:currencyList="currencyData" v-bind:lang="showLang[selectLang]" v-bind:defaultLayout="defaultLayout" v-bind:useDefaultLayout="useDefaultLayout" @childTargetKW="methodTargetKW" @childTargetDM="methodTargetDM" @childTargetLA="methodTargetLA" @childTargetCR="methodTargetCR" @childTargetAD="methodTargetAD" />
          <BenefitsAndInvestment ref="childBenefitAndContribution" v-bind:editPage="cancelEdit" v-bind:viewDatalist="benefitsAndInvestmentData" v-bind:lang="showLang[selectLang]" />
          <CustomRules v-if="showTargetCR" v-bind:editPage="cancelEdit" v-bind:viewDatalist="keywordData" v-bind:defaultStage="defaultStage" v-bind:stageMenu="stageMenu" v-bind:menu="menu" v-model:customRulesDataList="customRulesData"  v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childKeywordUrl="keywordUrl" @childHaveTest="haveTest" />
          <StageDynamicBudget v-if="showTargetCR" v-bind:editPage="cancelEdit" v-bind:viewDatalist="dynBudgetData" v-bind:lang="showLang[selectLang]" />
          <StageDoForward v-if="showTargetCR == true || showOtherTargetCR == true" v-bind:editPage="cancelEdit" v-bind:viewDatalist="doForwardData" v-bind:lang="showLang[selectLang]" />
          <KeywordMix ref="childKeywordMix" v-if="showTargetAD || showTargetKW || showTargetLA" v-bind:editPage="cancelEdit" v-bind:targetKW="showTargetKW" v-bind:targetAD="showTargetAD" v-bind:viewDatalist="keywordData" v-bind:lang="showLang[selectLang]" />
          <AdvertisingMix ref="childAdvertisingMix" v-if="showTargetLA" v-bind:showAdvertisingMix="showAdvertisingMix" v-bind:editPage="cancelEdit" v-bind:viewDatalist="lookData" v-bind:lang="showLang[selectLang]" />
          <RemarketingMix ref="childRemarketingMix" v-if="showTargetRT" v-bind:showRemarketingMix="showRemarketingMix" v-bind:editPage="cancelEdit" v-bind:viewDatalist="audiencesData" v-bind:adaccountId="adaccount_id" v-bind:pixelId="formPixelId" v-bind:productUrl="productUrl" v-bind:lang="showLang[selectLang]" />
          <ConfidentialAudience v-if="showTargetCF" v-bind:showMarketingDate="showMarketingDate" v-bind:editPage="cancelEdit" v-bind:viewDatalist="dateData" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" @checkClose="changeYoutubeType" @childYoutube="childYoutube" />
          <MarketingDate ref="childMarketingDate" v-bind:showMarketingDate="showMarketingDate" v-bind:editPage="cancelEdit" v-bind:viewDatalist="dateData" v-bind:lang="showLang[selectLang]" v-bind:efficientAi="efficientAi" />
        </div>
        <div v-show="target == 2">
          <div v-show="showTargetCR || useDefaultLayout !== null">
            <StageBlock v-bind:editPage="cancelEdit" v-model:viewDatalist="campaign_name" v-model:customRulesDataList="customRulesData"  @childCampaignName="campaignData" v-bind:lang="showLang[selectLang]" @childChangeEdit="changeEdit"/>
            <StageKeywordMix v-bind:editPage="cancelEdit" v-bind:targetKW="showTargetKW" v-bind:targetAD="showTargetAD" v-bind:viewDatalist="customRulesData.subCampaignsContent[customRulesData.editIndex].keywordData" v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childKeywordUrl="keywordUrl" />
            <StageAdvertisingMix v-bind:showAdvertisingMix="showAdvertisingMix" v-bind:editPage="cancelEdit" v-bind:viewDatalist="customRulesData.subCampaignsContent[customRulesData.editIndex].lookData" v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]" v-bind:adaccountId="adaccount_id" v-bind:pixelId="formPixelId" v-bind:productUrl="productUrl" v-bind:lang="showLang[selectLang]" />
            <StageRemarketingMix v-bind:showRemarketingMix="showRemarketingMix" v-bind:editPage="cancelEdit" v-bind:viewDatalist="customRulesData.subCampaignsContent[customRulesData.editIndex].audiencesData" v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]" v-bind:adaccountId="adaccount_id" v-bind:pixelId="formPixelId" v-bind:productUrl="productUrl" v-bind:lang="showLang[selectLang]" />
            <StageGoalsAndBudget v-bind:showGoalsAndBudget="showGoalsAndBudget" v-bind:stageContentAll="customRulesData" v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]" v-bind:stageContentLength="customRulesData.subCampaignsContent.length" v-bind:stageIndex="customRulesData.editIndex" v-bind:editPage="cancelEdit" v-bind:viewDatalist="goalsData" v-bind:getDate="returnGapTime" v-bind:budgetKWTotal="budgetKW" v-bind:useEndDate="returnUseEndDate" v-bind:formMinAddition="updateMinAddition" v-bind:currencyList="currencyData" v-bind:lang="showLang[selectLang]" v-bind:useLang="selectLang" v-bind:youtubeClose="youtubeClose" v-bind:showTargetCR="showTargetCR" v-bind:useDefaultLayout="useDefaultLayout" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childObjective="goalsObjective" @childObjectiveOption="objectiveOption"/>
            <StageRegions v-bind:editPage="cancelEdit" v-bind:viewDatalist="regionsData" v-bind:stageContentAll="customRulesData" v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]" v-bind:stageIndex="customRulesData.editIndex" v-bind:viewRelationshipDatalist="exAudiencesData" v-bind:campaignId="campaign_id" v-bind:targetDM="showTargetDM" v-model:selectCountries="selectCountries" v-model:selectLangs="selectLangs" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" @checkClose="changeYoutubeType" @childYoutube="childYoutube" />
            <StagePositionDeviceIdentity v-bind:editPage="cancelEdit" v-bind:viewDatalist="pdData" v-bind:stageContentAll="customRulesData" v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]" v-bind:stageIndex="customRulesData.editIndex" v-bind:autoPublisher="auto_publisher" v-bind:publisherPlatforms="publisher_platforms" v-bind:lang="showLang[selectLang]" v-bind:showIdentity="showIdentity" v-bind:viewIdentityDatalist="idData" @checkClose="changeYoutubeType" @childYoutube="childYoutube" v-bind:youtubeClose="youtubeClose" @childPageId="eventPageId" />
            <StageMaterial v-bind:showStageMaterial="showStageMaterial" v-bind:showStageAdvertisingMaterial="showStageAdvertisingMaterial" v-bind:showStageForm="showStageForm" v-bind:showStageMsg="showStageMsg" v-bind:editPage="cancelEdit" v-bind:viewDatalist="customRulesData.subCampaignsContent[customRulesData.editIndex].postData" v-model:viewAdMaterialDatalist="customRulesData.subCampaignsContent[customRulesData.editIndex].adMaterialData" v-bind:viewFormDatalist="idData" v-bind:stageContentAll="customRulesData" v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]" v-bind:stageIndex="customRulesData.editIndex" v-bind:pageId="formPageId" v-bind:goalsObjective="getGoalsObjective" v-bind:campaignId="campaign_id" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" v-bind:changeFormId="changeFormId" v-bind:changeMessageId="changeMessageId" v-bind:firstFormId="first_form_id" v-bind:formStatus="form_status" v-bind:formId="formId" v-bind:firstMessageId="first_message_id" v-bind:messageStatus="message_status" v-bind:messageId="messageId" v-bind:useTeachDetail="use_teach_detail" v-bind:useDefaultLayout="useDefaultLayout" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childActiveScroll="activeScroll" @childFormId="eventFormId" @childMessageId="eventMessageId" @childContent="adMaterialContent" @childChangeMessageId="formChangeMessageId"/>
          </div>
          <div v-show="showTargetCR != true && useDefaultLayout === null">
            <GoalsAndBudget ref="childGoalsAndBudget" v-bind:showGoalsAndBudget="showGoalsAndBudget" v-bind:editPage="cancelEdit" v-bind:viewDatalist="goalsData" v-bind:dbRiskLevelCode="dbRiskLevelCode" v-bind:getDate="returnGapTime" v-bind:budgetKWTotal="budgetKW" v-bind:useEndDate="returnUseEndDate" v-bind:formMinAddition="updateMinAddition" v-bind:currencyList="currencyData" v-bind:lang="showLang[selectLang]" v-bind:useLang="selectLang" v-bind:efficientAi="efficientAi" @childObjective="goalsObjective"/>
            <Regions ref="childRegions" v-bind:editPage="cancelEdit" v-bind:viewDatalist="regionsData" v-bind:targetDM="showTargetDM" v-model:selectCountries="selectCountries" v-model:selectLangs="selectLangs" v-bind:lang="showLang[selectLang]" />
            <Relationship ref="childRelationship" v-bind:showRelationship="showRelationship" v-bind:editPage="cancelEdit" v-bind:viewDatalist="exAudiencesData" v-bind:lang="showLang[selectLang]" v-bind:efficientAi="efficientAi" />
          </div>
        </div>
        <div v-show="target == 3">
          <div v-show="showTargetCR != true && useDefaultLayout === null">
            <PositionAndDevice ref="childPositionDevice" v-bind:editPage="cancelEdit" v-bind:viewDatalist="pdData" v-bind:autoPublisher="auto_publisher" v-bind:publisherPlatforms="publisher_platforms" v-bind:lang="showLang[selectLang]" />
            <Identity ref="childIdentity" v-bind:showIdentity="showIdentity" v-bind:editPage="cancelEdit" v-bind:viewDatalist="idData" v-bind:lang="showLang[selectLang]" @childPageId="eventPageId" />
            <Material ref="childMaterial" v-if="showMaterial" v-bind:editPage="cancelEdit" v-bind:viewDatalist="postData" v-bind:pageId="formPageId" v-bind:goalsObjective="getGoalsObjective" v-bind:campaign_objective="goalsData.campaign_objective" v-bind:campaignId="this.$route.params.campaign_id" v-bind:lang="showLang[selectLang]" v-bind:efficientAi="efficientAi" @childIsChangeData="materialChange" @childActiveScroll="activeScroll" />
            <AdvertisingMaterial ref="childCustomizeMaterial" v-bind:editPage="cancelEdit" v-bind:viewDatalist="adMaterialDataNew" v-bind:pageId="formPageId" v-bind:goalsObjective="getGoalsObjective" v-bind:returnCampaignObjective="returnCampaignObjective" v-bind:changeFormId="changeFormId" v-bind:lang="showLang[selectLang]" @childFormId="eventFormId" @childMessageId="eventMessageId" @childContent="adMaterialContent" @childAdIsChangeData="adMaterialChange" :style="showAdvertisingMaterial ? '' : 'display:none;'" />
            <Form v-if="showForm" v-bind:editPage="cancelEdit" v-bind:viewDatalist="idData" v-bind:pageId="formPageId" v-bind:firstFormId="first_form_id" v-bind:formStatus="form_status" v-bind:formId="formId" v-bind:useTeachDetail="use_teach_detail" v-bind:selectLang="selectLang" v-bind:lang="showLang[selectLang]" @childChangeFormId="formChangeFormId" />
            <Msg v-if="showMsg" v-bind:editPage="cancelEdit" v-bind:viewDatalist="idData" v-bind:pageId="formPageId" v-bind:firstMessageId="first_message_id" v-bind:messageStatus="message_status" v-bind:messageId="messageId" v-bind:useTeachDetail="use_teach_detail" v-bind:lang="showLang[selectLang]" />
          </div>
        </div>
      </div>
    </main>
    <footer class="block bg-white fixed w-full bottom-0">
      <div v-if="false" class="h-1 bg-green-700 progressbar" style="width:20%" :style="{width: `${process}%`}"></div>
      <div class="mx-auto pl-8 pr-28 py-4">
        <div class="flex flex-wrap items-center md:justify-between justify-center">
          <div class="border-gray-400 space-x-2">
            <button
              v-if="!efficientAi"
              class="bg-blue-600 hover:bg-blue-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-white transition duration-500 ease-in-out border-2 border-blue-400"
              @click="form_update()"
              >{{showLang[selectLang]['views']['EventBrowse']['save_button']}}</button>
            <button
              class="text-blue-600 focus:outline-none rounded-xl px-4 py-1.5 text-white transition duration-500 ease-in-out border border-blue-600 text-sm"
              @click="showDialog = true">
              投遞建議
            </button>
            <button
              class="bg-yellow-300 hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-blue-800 transition duration-500 ease-in-out border-2 border-yellow-400" v-if="false">{{showLang[selectLang]['views']['EventBrowse']['release_button']}}</button>
          </div>
          <div class="border-gray-400 space-x-2">
            <span v-if="false">{{showLang[selectLang]['views']['EventBrowse']['process_text_a']}} {{process}} % {{showLang[selectLang]['views']['EventBrowse']['process_text_b']}}</span>
          </div>
          <div class="border-gray-400 space-x-2 mr-16">
            <button
              v-if="target != 1"
              class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 text-blue-400 transition duration-500 ease-in-out border-blue-400 border-2"
              @click="prev()"
              :disabled="process <= 0"
            >{{showLang[selectLang]['views']['EventBrowse']['prev_text']}}</button>
            <button
              v-if="(target != 3 && useDefaultLayout === null && showTargetCR == false) || (target == 1 && useDefaultLayout !== null) || (target == 1 && showTargetCR == true)"
              class="hover:bg-green-200 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-green-400 border-2 bg-green-400"
              @click="next()"
              :disabled="process >= 66"
            >{{showLang[selectLang]['views']['EventBrowse']['next_text']}}</button>
          </div>
        </div>
      </div>
    </footer>

    <Dialog :visible="showDialog">
      <template #header>
        <h2 class="text-xl font-semibold">投遞策略選擇</h2>
      </template>

      <form @submit.prevent="handleSubmit">
        <div class="mb-4">
          <label class="block mb-2 font-semibold">請選擇一個策略：</label>

          <div class="mb-2">
            <label class="inline-flex items-center">
              <input
                type="radio"
                class="form-radio text-blue-600"
                name="strategy"
                value="策略A"
                v-model="form.strategy"
                required
              />
              <span class="ml-2">策略 A（較保守）</span>
            </label>
          </div>

          <div>
            <label class="inline-flex items-center">
              <input
                type="radio"
                class="form-radio text-blue-600"
                name="strategy"
                value="策略B"
                v-model="form.strategy"
              />
              <span class="ml-2">策略 B（較積極）</span>
            </label>
          </div>
        </div>
      </form>

      <template #footer>
        <button type="submit" class="bg-green-500 text-white px-2 py-1 rounded">
          確定
        </button>
        <button @click="showDialog = false" class="bg-gray-200 text-gray-700 px-2 py-1 rounded ml-1">
          關閉
        </button>
      </template>
    </Dialog>
  </div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import CampaignName from '@/components/Event/CampaignName.vue'
  import MarketingMethod from '@/components/Event/MarketingMethod.vue'
  import BenefitsAndInvestment from '@/components/Event/BenefitsAndInvestment.vue'
  import MarketingDate from '@/components/Event/MarketingDate.vue'
  import CustomRules from '@/components/Event/CustomRules.vue'
  import KeywordMix from '@/components/Event/KeywordMix.vue'
  import AdvertisingMix from '@/components/Event/AdvertisingMix.vue'
  import StageDynamicBudget from '@/components/Event/StageDynamicBudget.vue'
  import StageDoForward from '@/components/Event/StageDoForward.vue'
  import StageKeywordMix from '@/components/Event/StageKeywordMix.vue'
  import StageAdvertisingMix from '@/components/Event/StageAdvertisingMix.vue'
  import StageRemarketingMix from '@/components/Event/StargeRemarketingMix.vue'
  import StageBlock from '@/components/Event/StageBlock.vue'
  import StageGoalsAndBudget from '@/components/Event/StageGoalsAndBudget.vue'
  import StageRegions from '@/components/Event/StageRegions.vue'
  import StagePositionDeviceIdentity from '@/components/Event/StagePositionDeviceIdentity.vue'
  import StageMaterial from '@/components/Event/StageMaterial.vue'
  import GoalsAndBudget from '@/components/Event/GoalsAndBudget.vue'
  import Regions from '@/components/Event/Regions.vue'
  import Identity from '@/components/Event/Identity.vue'
  import Relationship from '@/components/Event/Relationship.vue'
  import PositionAndDevice from '@/components/Event/PositionAndDevice.vue'
  import Material from '@/components/Event/Material.vue'
  import AdvertisingMaterial from '@/components/Event/AdvertisingMaterial.vue'
  import Form from '@/views/Form.vue'
  import Msg from '@/views/Msg.vue'
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import CircleProgress from "vue3-circle-progress";
  import Dialog from '@/components/Dialog.vue'
  import axios from 'axios'
  import Qs from 'qs'
  import lang from '@/language/lang.json'
  import { reactive, toRaw } from 'vue';

  export default {
    name: 'Home',
    components: {
      Header,
      CampaignName,
      MarketingMethod,
      BenefitsAndInvestment,
      MarketingDate,
      CustomRules,
      KeywordMix,
      AdvertisingMix,
      StageDynamicBudget,
      StageDoForward,
      StageKeywordMix,
      StageAdvertisingMix,
      StageRemarketingMix,
      StageBlock,
      StageGoalsAndBudget,
      StageRegions,
      StagePositionDeviceIdentity,
      StageMaterial,
      GoalsAndBudget,
      Regions,
      Identity,
      Relationship,
      PositionAndDevice,
      Material,
      AdvertisingMaterial,
      Form,
      Msg,
      Loading,
      CircleProgress,
      Dialog
    },
    data() {
      return {
        selectLang: 'zh-TW',
        showLang: lang,
        use_teach_detail: false, // <!-- 新手教學 -->
        showCampaignData: false,
        showMarketingDate: true,
        showAdvertisingMix:'true_0000',
        showRemarketingMix:'true_0000',
        showGoalsAndBudget: true,
        showRelationship: true,
        showIdentity: true,
        display: false,
        cancelEdit: true,
        process: 0,
        showTargetKW: true,
        showTargetDM: true,
        showTargetLA: true,
        showTargetAD: true,
        showTargetCR: true,
        returnCampaignObjective: null,
        returnGapTime: null,
        returnEndTime: null,
        returnUseEndDate: null,
        budgetKW:null,
        updateMinAddition: 0,
        getGoalsObjective: null,
        showMaterial:true,
        showAdvertisingMaterial:true,
        showForm:true,
        showMsg:true,
        isEdit: false,
        campaign_id: null,
        campaign_name: null,
        adaccount_id: null,
        adaccount_name: null,
        target: 1,
        formPageId: null,
        formId: null,
        messageId: null,
        changeFormId: null,
        dbRiskLevelCode: null,
        menu: [],
        currencyData: {
                      currency: '',
                      currency_name: null,
                      currency_symbol: null,
                      currency_min_price: null,
                      currency_video_min_price: null,
                      currency_suggest_price: null,
                      currency_remarketing_price: null,
                      currency_offset: 1,
                    },
        methodData: {
                    Target_KW:null,
                    Budget_KW:null,
                    Target_DM:null,
                    Budget_DM:null,
                    Target_LA:null,
                    Budget_LA:null,
                    Target_RT:null,
                    Budget_RT:null,
                    use_confldential_audience_status:0,
                    Target_CF:null,
                    Budget_CF:null,
                    Target_AD:null,
                    Budget_AD_min:null,
                    Budget_AD_max:null,
                    Target_CR:null,
                    retargeting:null,
                    daily_budget:null
                  },
        benefitsAndInvestmentData: {
          useFinance: false,
          toTaiwan: false,
          benefits: null,
          benefits_list: [],
          investment: null,
          investment_list: [],
          person_or_business: {label : '個人或商家驗證', value : 1},
          beneficiary_id: null,
          payer_id: null,
          beneficiary_name: null,
          payer_name: null,
          beneOrPayerPersonalList:[],
          selectedBeneficiary: null,
          selectedPayer: null,
          showKeyinBeneficiary: null,
          showKeyinPayer: null,
        },
        customRulesData: {
          editIndex: 0,
          haveTest: true,
          stageList: [
            { marketingValue: 'META_KW'},
          ],
          subCampaignsContent: [
            {
              method : 'META_TEST',
              release : {
                sr_i : 0,
                status : ''
              },
              goalsData: {
                showBlock: true,
                campaign_objective: null,
                objective_option:null,
                objective_list:null,
                product_catalog_list:null,
                product_set_list:null,
                optimization_action:null,
                optimization_goal:null,
                product_catalog_id:null,
                product_set_id:null,
                pixel_id:null,
                pixel_event:null,
                conversion_domain:null,
                domain_list:null,
              },
              budgetData: {
                showBlock: true,
                daily_budget:0,
                effect:null,
                currency_video_min_price:null,
                form_addition:null,
                use_addition:null,
                risk_automatic:null,
                risk_index:null,
                risk_level_list:null,
                risk_level:null
              },
              forwardData: {
                showBlock: true,
                ditto_forward: '0',
                frequency: '1d',
                rule_frequency: [],
              },
              stopData: {
                showBlock: true,
                ditto_stop: '0',
                rule_stop: [],
              },
              budgetExtraData: {
                showBlock: true,
                ditto_budget_extra: '0',
                amount: 0,
                frequency: 0,
                budget_extra_list: [],
              },
              localData: {
                showBlock: true,
                ditto_local: '0',
                location_types:null,
                locations:null,
                location_range:null,
                locales:null
              },
              demoData: {
                showBlock: true,
                ditto_demo: '0',
                gender:null,
                age_min:null,
                age_max:null
              },
              exAudiencesData: {
                showBlock: true,
                ditto_connect: '0',
                excluded_audiences:null,
                default_excluded_audiences:null,
                custom_excluded_audiences:null,
                custom_excluded_audiences_selected:null,
              },
              pdData: {
                showBlock: true,
                ditto_identity: '0',
                auto_publisher:null,
                publisher_platforms:null,
                publisher_platforms_list:null,
                device_platforms: null,
                user_os:null,
                user_os_list:null,
                page_id:null,
                ig_id:null,
                ig_username:null,
                adpages_list:null,
                ig_list:null,
              },
              postData: {
                showBlock: true,
                ditto_creative: '0',
                page_id:null,
                special_ad_category:null,
                disabled_creative_optimize:false,
                creative_optimize:false,
                select_article:null,
                db_select_article:null,
                select_creatives:null,
                db_select_creatives:null,
                select_creatives_message:null,
                db_select_creatives_message:null,
                select_creatives_adset_ads:null,
                db_select_creatives_adset_ads:null,
                select_creatives_adset_ads_message:null,
                db_select_creatives_adset_ads_message:null,
              },
              adMaterialData: {
                showBlock: true,
                ditto_creative: '0',
                disabled_creative_optimize:false,
                creative_optimize:false,
                creative_array:null,
              },
            },
          ]
        },
        otherCustomTitle:[],
        defaultLayout: [],
        defaultStage: [],
        stageMenu: [],
        dynBudgetData: {
          useDynamicBudget: false
        },
        doForwardData: {
          useDoForward: false
        },
        dateData: {
                    start_date:null,
                    end_date:null
                  },
        keywordData: {
                      product_url:null,
                      keywords:null,
                      base_keyword_list: [],
                      select_keywords:null
                    },
        lookData: {
                    default_lookalikes:null,
                    custom_lookalikes:null,
                    custom_lookalikes_selected:null,
                    default_lookalikes_list:null,
                    custom_lookalikes_list:null
                  },
        goalsData: {
                    campaign_objective:null,
                    objective_option:null,
                    objective_list:null,
                    product_catalog_list:null,
                    product_set_list:null,
                    optimization_action:null,
                    optimization_goal:null,
                    product_catalog_id:null,
                    product_set_id:null,
                    pixel_id:null,
                    pixel_event:null,
                    conversion_domain:null,
                    domain_list:null,
                    useAppEvent: false,
                    appItemsSelected: null,
                    appItemsList: [],
                    effect:null,
                    currency_video_min_price:null,
                    form_addition:null,
                    use_addition:null,
                    risk_automatic:null,
                    risk_index:null,
                    risk_level_list:null,
                    risk_level:null
                  },
        regionsData: {
                      location_types:null,
                      locations:null,
                      location_range:null,
                      locales:null,
                      gender:null,
                      age_min:null,
                      age_max:null
                    },
        selectCountries: null,
        selectLangs: null,
        exAudiencesData: {
                      excluded_audiences:null,
                      default_excluded_audiences:null,
                      custom_excluded_audiences:null,
                      custom_excluded_audiences_selected:null,
                    },
        pdData: {
                  auto_publisher:null,
                  publisher_platforms:null,
                  publisher_platforms_list:null,
                  device_platforms: null,
                  user_os:null,
                  user_os_list:null,
                },
        auto_publisher: null,
        publisher_platforms: null,
        idData: {
                  page_id:null,
                  ig_id:null,
                  ig_username:null,
                  adpages_list:null,
                  ig_list:null,
                },
        postData: {
                  page_id:null,
                  special_ad_category:null,
                  disabled_creative_optimize:false,
                  creative_optimize:false,
                  select_article:null,
                  delete_article:null,
                  db_select_article:null,
                  select_creatives:null,
                  delete_creatives:null,
                  db_select_creatives:null,
                  select_creatives_message:null,
                  delete_creatives_message:null,
                  db_select_creatives_message:null,
                  select_creatives_adset_ads:null,
                  delete_creatives_adset_ads:null,
                  db_select_creatives_adset_ads:null,
                  select_creatives_adset_ads_message:null,
                  delete_creatives_adset_ads_message:null,
                  db_select_creatives_adset_ads_message:null,
                  material_creative_tags:null,
                  material_post_tags:null,
                  material_post_delete_tags:null,
                  material_creative_delete:null,
                  material_creative_delete_adset_ads:null,
                },
        adMaterialData: {
                          disabled_creative_optimize:false,
                          creative_optimize:false,
                          creative_array:null,
                        },
        tmpAdMaterialDataNew:{
                            disabled_creative_optimize:false,
                            creative_optimize:false,
                            creative_array:null,
                          },
        adMaterialDataNew:{
                            disabled_creative_optimize:false,
                            creative_optimize:false,
                            creative_array:null,
                          },
        formData: {
                    pageId: null,
                    formId: null
                  },
        msgData: {
                    pageId: null,
                    msgId: null
                  },
        first_form_id: null,
        form_status: null,
        first_message_id: null,
        message_status: null,
        isChangeDataMaterial: false,
        isChangeDataAdMaterial: false,
        releaseType: true,
        efficientAi: null,
        style: 'z-index: -1;',
        releaseText: '發佈中...',
        releasePercent: 5,
        subCampaignList: [],
        useDefaultLayout: null,
        showDialog: false,
        form: {}
      }
    },
    created() {
      // console.log('id:'+this.$route.params.id);
      // console.log('adaccount_id:'+this.$route.params.adaccount_id);
      // console.log('campaign_id:'+this.$route.params.campaign_id);

      let hash = this.$route.params.id;

      if(hash != '' && hash != null && typeof hash != 'undefined'){
        axios
          .post('https://test.autoturn.net/inside/api/lib/default_stage.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
          }))
          .then((dsResponse) => {
            // console.log('dsResponse:'+dsResponse.data.selecded_data);
            console.log('lib default_stage.php');
            console.log(dsResponse.data);
            if(dsResponse.data.status == 'success'){
              this.defaultStage = dsResponse.data.return_data;
              this.stageMenu = dsResponse.data.menu;

              console.log('this.defaultStage');
              console.log(this.defaultStage);
              console.log('this.stageMenu');
              console.log(this.stageMenu);

              axios
                .post('https://test.autoturn.net/inside/api/campaign.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  adaccount_id: this.$route.params.adaccount_id,
                  campaign_id: this.$route.params.campaign_id
                }))
                .then((response) => {
                  if(response.data.status == 'success'){
                    this.campaign_id = this.$route.params.campaign_id
                    this.campaign_name = response.data.return_data.campaign_name
                    this.adaccount_id = response.data.return_data.adaccount_id
                    this.adaccount_name = response.data.return_data.adaccount_name

                    document.title = response.data.return_data.campaign_name+' - '+this.showLang[this.selectLang]['views']['EventBrowse']['created']['page_title']+' - AutoTurn';

                    console.log('b this.showTargetCR');
                    console.log(this.showTargetCR);

                    this.showTargetKW = response.data.return_data.Target_KW
                    this.showTargetLA = response.data.return_data.Target_LA
                    this.showTargetAD = response.data.return_data.Target_AD
                    this.showTargetCR = response.data.return_data.Target_CR

                    this.useDefaultLayout = response.data.return_data.use_Default_Layout;

                    console.log('response.data.return_data.Target_CR');
                    console.log(response.data.return_data.Target_CR);
                    console.log('a this.showTargetCR');
                    console.log(this.showTargetCR);

                    this.benefitsAndInvestmentData = {
                      toTaiwan: response.data.return_data.toTaiwan,
                      useFinance: response.data.return_data.useFinance,
                      benefits: response.data.return_data.benefits,
                      benefits_list: response.data.return_data.benefits_list,
                      investment: response.data.return_data.investment,
                      investment_list: response.data.return_data.investment_list,
                      person_or_business: response.data.return_data.person_or_business,
                      beneficiary_id: response.data.return_data.beneficiary_id,
                      payer_id: response.data.return_data.payer_id,
                      beneficiary_name: response.data.return_data.beneficiary_name,
                      payer_name: response.data.return_data.payer_name,
                      beneOrPayerPersonalList: response.data.return_data.beneficiary_or_payer_personal_list,
                      selectedBeneficiary: response.data.return_data.selected_beneficiary,
                      selectedPayer: response.data.return_data.selected_payer,
                      showKeyinBeneficiary: response.data.return_data.show_keyin_beneficiary,
                      showKeyinPayer: response.data.return_data.show_keyin_payer,
                    };

                    this.defaultLayout = response.data.return_data.default_layout;

                    if(this.showTargetCR == true || this.useDefaultLayout !== null){
                      console.log('#00');
                      let subCampaigns = response.data.return_data.sub_campaigns;
                      this.subCampaignList = response.data.return_data.sub_campaigns;

                      this.menu = [
                        {
                          title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_title'],
                          submenu: [
                            {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_0_title'], show: true, checked: false},
                            {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_1_title'], show: true, checked: false},
                            {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_2_title'], show: true, checked: false},
                            {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_3_title'], show: true, checked: false},
                            {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_4_title'], show: true, checked: false},
                            {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_7_title'], show: true, checked: false},
                            {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_6_title'], show: true, checked: false},
                          ],
                          open: true,
                          show: true,
                          target: 1
                        },
                      ];

                      if(subCampaigns != '' && subCampaigns != null && typeof subCampaigns != 'undefined'){
                        if(subCampaigns.length > 0){
                          console.log('#01');

                          // this.customRulesData.stageList = [];
                          // this.customRulesData.subCampaignsContent = [];

                          console.log('before db this.customRulesData');
                          console.log(this.customRulesData);

                          console.log('this.fetchData');
                          this.fetchData(subCampaigns, response);
                        } else {
                          this.methodTargetCR(true);
                          this.showCampaignData = true;
                        }
                      } else {
                        this.methodTargetCR(true);
                        this.showCampaignData = true;
                      }
                    }

                    let startTime = response.data.return_data.start_date;
                    let endTime = response.data.return_data.end_date;
                    let diffType = 'day';

                    let gapTime = 0;

                    if(startTime != '' && startTime != '0000-00-00' && startTime != null && endTime != '' && endTime != '0000-00-00' && endTime != null){
                      diffType = diffType.toLowerCase();
                      var sTime =new Date(startTime); //開始時間
                      var eTime =new Date(endTime); //結束時間
                      //作為除數的數字
                      var timeType = 1;
                      switch (diffType) {
                          case"second":
                              timeType =1000;
                          break;
                          case"minute":
                              timeType =1000*60;
                          break;
                          case"hour":
                              timeType =1000*3600;
                          break;
                          case"day":
                              timeType =1000*3600*24;
                          break;
                          default:
                          break;
                      }
                      gapTime = parseInt((eTime.getTime() - sTime.getTime()) / parseInt(timeType));
                    }

                    this.budgetKW = response.data.return_data.Budget_KW;
                    this.returnGapTime = gapTime;
                    this.returnEndTime = response.data.return_data.end_date;
                    this.returnUseEndDate = response.data.return_data.use_end_date;

                    this.currencyData = {
                                          currency: response.data.return_data.currency,
                                          currency_name: response.data.return_data.currency_name,
                                          currency_symbol: response.data.return_data.currency_symbol,
                                          currency_min_price: response.data.return_data.currency_min_price,
                                          currency_video_min_price: response.data.return_data.currency_video_min_price,
                                          currency_suggest_price: response.data.return_data.currency_suggest_price,
                                          currency_remarketing_price: response.data.return_data.currency_remarketing_price,
                                          KW_min_price: response.data.return_data.KW_min_price,
                                          DM_min_price: response.data.return_data.DM_min_price,
                                          LA_min_price: response.data.return_data.LA_min_price,
                                          RT_min_price: response.data.return_data.RT_min_price,
                                          currency_offset: response.data.return_data.offset,
                                        }

                    this.methodData = {
                                        Target_KW : response.data.return_data.Target_KW,
                                        Budget_KW : response.data.return_data.Budget_KW,
                                        Target_DM : response.data.return_data.Target_DM,
                                        Budget_DM : response.data.return_data.Budget_DM,
                                        Target_LA : response.data.return_data.Target_LA,
                                        Budget_LA : response.data.return_data.Budget_LA,
                                        Target_RT : response.data.return_data.Target_RT,
                                        Budget_RT : response.data.return_data.Budget_RT,
                                        Target_CF : response.data.return_data.Target_CF,
                                        Budget_CF : response.data.return_data.Budget_CF,
                                        Target_AD : response.data.return_data.Target_AD,
                                        Budget_AD_min : response.data.return_data.Budget_AD_min,
                                        Budget_AD_max : response.data.return_data.Budget_AD_max,
                                        Target_CR : response.data.return_data.Target_CR,
                                        use_confldential_audience_status : response.data.return_data.use_confldential_audience_status,
                                        retargeting : response.data.return_data.retargeting,
                                        daily_budget : response.data.return_data.daily_budget
                                      }

                    if(response.data.return_data.Target_LA == '1'){
                      var todayForm = new Date();
                      var yearForm = todayForm.getFullYear();
                      var dateForm = String(todayForm.getDate()).padStart(2, '0');
                      var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                      var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                      let get_value_la = 'false_'+yearForm + monthForm + dateForm + timeForm;

                      this.showAdvertisingMix = get_value_la;
                    }

                    if(response.data.return_data.Target_RT == '1'){

                      var todayForm = new Date();
                      var yearForm = todayForm.getFullYear();
                      var dateForm = String(todayForm.getDate()).padStart(2, '0');
                      var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                      var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                      let get_value_rt = 'false_'+yearForm + monthForm + dateForm + timeForm;

                      this.showRemarketingMix = get_value_rt;
                    }

                    this.dynBudgetData = {
                      useDynamicBudget: response.data.return_data.use_dynamic_budget,
                    }

                    this.doForwardData = {
                      useDoForward: response.data.return_data.use_do_forward,
                    }

                    this.dateData = {
                                      start_date : response.data.return_data.start_date,
                                      end_date : response.data.return_data.end_date
                                    }

                    this.keywordData = {
                                          product_url : response.data.return_data.product_url,
                                          keywords : response.data.return_data.keywords,
                                          select_keywords : response.data.return_data.keywords
                                        },

                    this.lookData = {
                                      default_lookalikes : response.data.return_data.default_lookalikes,
                                      custom_lookalikes : response.data.return_data.custom_lookalikes,
                                      custom_lookalikes_selected : response.data.return_data.custom_lookalikes_selected,
                                      default_lookalikes_list : response.data.return_data.default_lookalikes_list,
                                      custom_lookalikes_list : response.data.return_data.custom_lookalikes_list
                                    }

                    this.audiencesData = {
                                      default_audiences : response.data.return_data.default_audiences,
                                      custom_audiences : response.data.return_data.custom_audiences,
                                      custom_audiences_selected : response.data.return_data.custom_audiences_selected,
                                      default_audiences_list : response.data.return_data.default_audiences_list,
                                      custom_audiences_list : response.data.return_data.custom_audiences_list
                                    }

                    this.goalsData = {
                                        campaign_objective : response.data.return_data.campaign_objective,
                                        objective_option : response.data.return_data.objective_option,
                                        objective_list : response.data.return_data.objective_list,
                                        product_catalog_list : response.data.return_data.product_catalog_list,
                                        product_set_list : response.data.return_data.product_set_list,
                                        optimization_action : response.data.return_data.optimization_action,
                                        optimization_goal : response.data.return_data.optimization_goal,
                                        product_catalog_id : response.data.return_data.product_catalog_id,
                                        product_set_id : response.data.return_data.product_set_id,
                                        useAppEvent: response.data.return_data.useAppEvent,
                                        appItemsSelected: response.data.return_data.appItemsSelected,
                                        appItemsList: response.data.return_data.appItemsList,
                                        pixel_id : response.data.return_data.pixel_id,
                                        pixel_event : response.data.return_data.pixel_event,
                                        conversion_domain : response.data.return_data.conversion_domain,
                                        domain_list: response.data.return_data.domain_list,
                                        effect : response.data.return_data.effect,
                                        currency_video_min_price: response.data.return_data.currency_video_min_price,
                                        form_addition : response.data.return_data.form_addition,
                                        use_addition : response.data.return_data.use_addition,
                                        risk_automatic : response.data.return_data.risk_automatic,
                                        risk_index : response.data.return_data.risk_index,
                                        risk_level_list: response.data.return_data.risk_level_list,
                                        risk_level: response.data.return_data.risk_level
                                      }

                    this.returnCampaignObjective = response.data.return_data.campaign_objective

                    this.dbRiskLevelCode = response.data.return_data.risk_level.code

                    this.regionsData = {
                                          location_types : response.data.return_data.location_types,
                                          locations : response.data.return_data.locations,
                                          location_range : response.data.return_data.location_range,
                                          locales : response.data.return_data.locales,
                                          gender : response.data.return_data.gender,
                                          age_min : response.data.return_data.age_min,
                                          age_max : response.data.return_data.age_max
                                        }

                    this.selectCountries = response.data.return_data.locations

                    this.selectLangs = response.data.return_data.locales

                    this.exAudiencesData = {
                                              excluded_audiences : response.data.return_data.excluded_audiences,
                                              default_excluded_audiences : response.data.return_data.default_excluded_audiences,
                                              custom_excluded_audiences : response.data.return_data.custom_excluded_audiences,
                                              custom_excluded_audiences_selected : response.data.return_data.custom_excluded_audiences_selected,
                                            }

                    this.pdData = {
                                    auto_publisher : response.data.return_data.auto_publisher,
                                    publisher_platforms : response.data.return_data.publisher_platforms,
                                    publisher_platforms_list : response.data.return_data.publisher_platforms_list,
                                    device_platforms: response.data.return_data.device_platforms,
                                    user_os : response.data.return_data.user_os,
                                    user_os_list : response.data.return_data.user_os_list
                                  }

                    this.auto_publisher = response.data.return_data.auto_publisher
                    this.publisher_platforms = response.data.return_data.publisher_platforms

                    this.idData = {
                                    page_id : response.data.return_data.page_id,
                                    ig_id : response.data.return_data.ig_id,
                                    ig_username : response.data.return_data.ig_username,
                                    adpages_list : response.data.return_data.adpages_list,
                                    ig_list : response.data.return_data.ig_list,
                                  }

                    this.postData = {
                                      page_id : response.data.return_data.page_id,
                                      special_ad_category : response.data.return_data.special_ad_category,
                                      disabled_creative_optimize : response.data.return_data.disabled_creative_optimize,
                                      creative_optimize : response.data.return_data.creative_optimize,
                                      db_select_article : response.data.return_data.post_ids,
                                      db_select_creatives : response.data.return_data.creatives_ids,
                                      db_select_creatives_message : response.data.return_data.creatives_message_ids,
                                      db_select_creatives_adset_ads : response.data.return_data.creatives_ids_adset_ads,
                                      db_select_creatives_adset_ads_message : response.data.return_data.creatives_adset_ads_message,
                                      material_creative_tags : response.data.return_data.material_creative_tags,
                                      material_post_tags : response.data.return_data.material_post_tags,
                                      material_post_delete_tags : response.data.return_data.material_post_delete_tags,
                                      material_creative_delete : response.data.return_data.material_creative_delete,
                                      material_creative_message_delete : response.data.return_data.material_creative_message_delete,
                                      material_creative_delete_adset_ads : response.data.return_data.material_creative_delete_adset_ads,
                                    }

                    console.log('main this.postData');
                    console.log(this.postData);

                    // if(response.data.return_data.campaign_objective == 'PRODUCT_CATALOG_SALES'){
                    //   this.postData.db_select_creatives_adset_ads = response.data.return_data.creatives_ids;
                    // } else {
                    //   this.postData.db_select_creatives = response.data.return_data.creatives_ids;
                    // }

                    this.adMaterialData = {
                                            disabled_creative_optimize : response.data.return_data.disabled_creative_optimize,
                                            creative_optimize : response.data.return_data.creative_optimize,
                                            creative_array : response.data.return_data.creative_array,
                                          }

                    this.tmpAdMaterialDataNew = {
                                                  disabled_creative_optimize : response.data.return_data.disabled_creative_optimize,
                                                  creative_optimize : response.data.return_data.creative_optimize,
                                                  creative_array : response.data.return_data.creative_array
                                                }

                    this.formPageId = response.data.return_data.page_id

                    this.first_form_id = response.data.return_data.first_form_id

                    this.form_status = response.data.return_data.form_status

                    this.first_message_id = response.data.return_data.first_message_id

                    this.message_status = response.data.return_data.message_status

                    console.log('this.tmpAdMaterialDataNew');
                    console.log(this.tmpAdMaterialDataNew);

                    this.minAddition(response.data.return_data.form_addition, gapTime, response.data.return_data.Budget_KW, this.returnUseEndDate);
                  }

                  if(response.data.status == 'login'){
                    Swal.fire({
                      icon: 'error',
                      title: '瀏覽/編輯頁',
                      text: '會員資料已過期，請重新登入。',
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: '確定'
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      /* Read more about isConfirmed, isDenied below */
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        // this.allPageLoading = true
                        window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        // this.allPageLoading = true
                        window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                      }
                    })
                  }

                  if(this.showTargetCR == false && this.useDefaultLayout === null){
                    this.showCampaignData = true;
                  }
                });
            } else {
              Swal.fire({
                icon: 'error',
                title: this.showLang[this.selectLang]['views']['EventBrowse']['created']['no_hash_swal_title'],
                text: dsResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['created']['no_hash_swal_confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  // this.allPageLoading = true
                  window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  // this.allPageLoading = true
                  window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                }
              })
            }
          });
      } else {
        Swal.fire({
          icon: 'error',
          title: this.showLang[this.selectLang]['views']['EventBrowse']['created']['no_hash_swal_title'],
          text: this.showLang[this.selectLang]['views']['EventBrowse']['created']['no_hash_swal_text'],
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['created']['no_hash_swal_confirm_button']
          // denyButtonText: `Don't save`,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            // Swal.fire('Saved!', '', 'success')
            // this.allPageLoading = true
            window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
          } else if (result.isDenied) {
            // Swal.fire('Changes are not saved', '', 'info')
            // this.allPageLoading = true
            window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
          }
        })
      }
    },
    Watch:{
      // 'formPageId': function(v){
      //   console.log('event formPageId');
      //   console.log(v);
      // },
      // 'idData.page_id': function(v){
      //   console.log('event idData.page_id');
      //   console.log(v);
      // }
      sub_campaigns(v){
        console.log('sub_campaigns');
        console.log(v);
      },
      'customRulesData': function(v){
        console.log('customRulesData');
        console.log(this.customRulesData)
      }
    },
    methods: {
      delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },
      fetchData(subCampaigns, response, method) {
        if (!response || !response.data || !response.data.return_data) {
          console.error('Invalid response data');
          return;
        }

        const haveTest = response.data.return_data.haveTest;

        // 使用 reduce 按顺序执行请求
        subCampaigns.reduce((promiseChain, value, index) => {
          let _toMenuIndex = index + parseInt(1);

          return promiseChain
            .then(() => {
              console.log(`Making request for item: ${value} at index: ${index}`);
              return axios.post('https://test.autoturn.net/inside/api/campaign_subset.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
                haveTest: haveTest,
                useDoForward: this.doForwardData.useDoForward,
                itemIndex: index,
                campaign_id: value,
                useOtherCustom: method,
                useFixedTemp: true
              }));
            })
            .then(subResponse => {
              console.log(`Fetched data for item: ${value}`);
              console.log('response.data:', subResponse.data);

              if(subResponse.data.status == 'success'){
                let _tmpReturnMenu = JSON.stringify(subResponse.data.return_menu);
                this.menu[_toMenuIndex] = JSON.parse(_tmpReturnMenu);
                this.customRulesData.haveTest = response.data.return_data.haveTest;

                if(subResponse.data.subset_method != 'META_TEST'){
                  let _toStageListIndex = index;
                  if(this.customRulesData.haveTest == true){
                    _toStageListIndex = index - parseInt(1);
                  }

                  console.log(typeof subResponse.data.return_stage_list);
                  console.log(subResponse.data.return_stage_list);
                  let _tmpReturnStageList = JSON.stringify(subResponse.data.return_stage_list);
                  this.customRulesData.stageList[_toStageListIndex] = JSON.parse(_tmpReturnStageList)
                }

                if(subResponse.data.subset_method == 'META_ASC'){
                  var todayForm = new Date();
                  var yearForm = todayForm.getFullYear();
                  var dateForm = String(todayForm.getDate()).padStart(2, '0');
                  var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                  var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                  todayForm = yearForm + monthForm + dateForm + timeForm;

                  this.haveASC = 'true_'+todayForm;
                }

                console.log(typeof subResponse.data.return_data);
                console.log(subResponse.data.return_data);
                // console.log('this.customRulesData.subCampaignsContent['+index+'] = JSON.parse(JSON.stringify('+subResponse.data.return_data+')');
                let _tmpReturnData = JSON.stringify(subResponse.data.return_data);
                // console.log(_tmpReturnData);
                // this.customRulesData.subCampaignsContent[index] = JSON.parse(_tmpReturnData);

                try {
                  JSON.parse(_tmpReturnData);
                  console.log("JSON 格式正确");
                } catch (error) {
                  console.error("JSON 格式错误:", error.message);
                }

                // this.customRulesData.subCampaignsContent.splice(index, 1, JSON.parse(_tmpReturnData));

                // if (!this.customRulesData.subCampaignsContent[index]) {
                //   this.customRulesData.subCampaignsContent.splice(index, 1, this.ensureReactive({}));
                // } else {
                //   // 确保对象是响应式的
                //   this.customRulesData.subCampaignsContent[index] = this.ensureReactive(this.customRulesData.subCampaignsContent[index]);
                // }

                if (!this.customRulesData.subCampaignsContent[index]) {
                  this.customRulesData.subCampaignsContent[index] = reactive({});
                }

                console.log('before db+ this.customRulesData');
                console.log(this.customRulesData);

                if (this.customRulesData.subCampaignsContent && index != null) {
                  const parsedData = JSON.parse(_tmpReturnData);

                  console.log('Index:', index);
                  console.log('Original Object:', this.customRulesData.subCampaignsContent[index]);
                  console.log('Data to Assign:', parsedData);

                  if(this.customRulesData.subCampaignsContent[index] != null && parsedData != null){
                    Object.assign(this.customRulesData.subCampaignsContent[index], parsedData);
                  }

                  // this.customRulesData.subCampaignsContent[index] = {
                  //     ...this.customRulesData.subCampaignsContent[index],
                  //     ...parsedData
                  // };

                  if(!this.customRulesData.subCampaignsContent[index]){
                    console.log('資料沒更新成功');
                  } else {
                    console.log("有資料");
                  }

                  console.log('this.customRulesData.subCampaignsContent['+index+']');
                  console.log(this.customRulesData.subCampaignsContent[index]);
                  console.log(this.customRulesData.subCampaignsContent);
                  console.log(this.customRulesData);
                } else {
                  console.error('subCampaignsContent 或 index 無效');
                }

                // console.log('check subCampaignsContent');
                // this.customRulesData.subCampaignsContent.forEach((checkValue, checkIndex) => {
                //   console.log(checkIndex);
                //   console.log(checkValue);
                // });

                console.log(index+ ' db+ this.customRulesData');
                console.log(this.customRulesData);

                console.log(index+ ' campaign_subset this.menu');
                console.log(this.menu);
              }

              if(_toMenuIndex == subCampaigns.length){
                console.log('db end this.showTargetCR');
                console.log(this.showTargetCR);
                console.log('campaign_subset done');
                this._tmpMenu = this.menu;
                console.log('fetchData this._tmpMenu');
                console.log(this._tmpMenu);
                this.showCampaignData = true;
              }
            })
            .catch(error => {
              console.error(`Error fetching data for item: ${value}`, error.subResponse ? error.subResponse.data : error.message);
            });
        }, Promise.resolve());
      },
      useLang(v){
        console.log('event methods useLang');
        console.log(v);

        if(v == '' || v == null || typeof v == 'undefined'){
          v = 'zh-TW';
        }

        this.selectLang = v

        this.$emit('childLang', v);

        console.log('useLang this.selectLang');
        console.log(this.selectLang);
        console.log('this.showLang['+v+']');
        console.log(this.showLang[v]);

        this.menu = [
          {
            title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_1_title'],
            submenu: [
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_1_submenu_0_title'], groupType: 'childCampaignName', refName: 'campaignName', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_1_submenu_1_title'], groupType: 'childMarketingMethod', refName: 'marketingMethod', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_1_submenu_8_title'], groupType: 'childBenefitAndContribution', refName: 'benefitAndContribution', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_1_submenu_2_title'], groupType: 'childAdStrategy', refName: 'adStrategy', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_1_submenu_3_title'], groupType: 'childKeywordMix', refName: 'keywordMix', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_1_submenu_4_title'], groupType: 'childAdvertisingMix', refName: 'advertisingMix', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_1_submenu_7_title'], groupType: 'childRemarketingMix', refName: 'remarketingMix', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_1_submenu_6_title'], groupType: 'childMarketingDate', refName: 'marketingDate', show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 1
          },
          // {
          //   title: '關鍵字與受眾',
          //   submenu: [
          //     {title: '精準興趣關鍵字', show: true, checked: false},
          //     {title: '類似受眾廣告組合', show: true, checked: false},
          //   ],
          //   open: true,
          //   show: true,
          //   target: 2
          // },
          {
            title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_2_title'],
            submenu: [
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_2_submenu_1_title'], groupType: 'childGoalsAndBudget', refName: 'goalsAndBudget', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_2_submenu_2_title'], groupType: 'childRegions', refName: 'regions', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_2_submenu_3_title'], groupType: 'childRelationship', refName: 'relationship', show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 2
          },
          {
            title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_3_title'],
            submenu: [
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_3_submenu_1_title'], groupType: 'childPositionDevice', refName: 'positionDevice', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_3_submenu_2_title'], groupType: 'childIdentity', refName: 'identity', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_3_submenu_3_title'], groupType: 'childMaterial', refName: 'material', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_3_submenu_4_title'], groupType: 'childCustomizeMaterial', refName: 'customizeMaterial', show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 3
          },
        ];
      },
      haveTest(value){
        let get_value = value.split('_');

        if(get_value[0] == 'false'){
          let subCampaignsContentLength = this.customRulesData.subCampaignsContent.length;
          let _tmpSubCampaignsContent = [];

          for(let i = 0; i < subCampaignsContentLength; i++){
            if(this.customRulesData.subCampaignsContent[i].method != 'META_TEST'){
              this.customRulesData.subCampaignsContent[i].goalsData.showBlock = true;
              this.customRulesData.subCampaignsContent[i].pdData.showBlock = true;
              this.customRulesData.subCampaignsContent[i].postData.showBlock = true;
              _tmpSubCampaignsContent.push(this.customRulesData.subCampaignsContent[i]);
            }
          }

          console.log('_tmpSubCampaignsContent');
          console.log(_tmpSubCampaignsContent);

          this.customRulesData.subCampaignsContent = _tmpSubCampaignsContent;
          this.customRulesData.editIndex = 0;

          let _tmpMenu = [];
          for(let i = 0; i < this.menu.length; i++){
            if(this.menu[i].title != '測試素材'){
              _tmpMenu.push(this.menu[i]);
            }
          }

          this.menu = _tmpMenu;
        } else {
          if(this.customRulesData.subCampaignsContent[0].method != 'META_TEST'){
            this.customRulesData.subCampaignsContent.unshift(this.defaultStage['USE_TEST']['META_TEST']);

            this.menu.splice(1, 0, this.stageMenu['USE_TEST']['META_TEST']);

            let subCampaignsContentLength = this.customRulesData.subCampaignsContent.length;
            let _tmpSubCampaignsContent = [];

            for(let i = 0; i < subCampaignsContentLength; i++){
              if(this.customRulesData.subCampaignsContent[i].method != 'META_TEST'){
                this.customRulesData.subCampaignsContent[i].goalsData.showBlock = false;
                this.customRulesData.subCampaignsContent[i].pdData.showBlock = false;
                this.customRulesData.subCampaignsContent[i].postData.showBlock = false;
              }

              _tmpSubCampaignsContent.push(this.customRulesData.subCampaignsContent[i]);
            }

            this.customRulesData.subCampaignsContent = _tmpSubCampaignsContent;
            this.customRulesData.editIndex = 0;
          }
        }

        console.log('haveTest');
        console.log(this.customRulesData);
        console.log(this.menu);
      },
      changeEdit(value){
        let get_value = value.split('_');

        this.customRulesData.editIndex = parseInt(get_value[0]);
      },
      minAddition(budgetAddition, day, budgetKW, useEndDate){
        // console.log('value budgetAddition:'+budgetAddition);

        // console.log('getDate budgetAddition:'+day);
        // console.log('budgetKWTotal budgetAddition:'+budgetKW);
        // console.log('useEndDate budgetAddition:'+useEndDate);

        // if(useEndDate == false){
        //   //有結束日期
        //   // console.log('有結束日期');
        //   //先算精準興趣總預算

        //   if(!isNaN(day) && day > 0){
        //     // console.log('有日期間距');
        //     var _tmp_days = day;
        //     var _tmp_total = budgetKW;
        //     // var _tmp_budget_addition = (budget_addition == '' || budget_addition == 0)?0:budget_addition/100
        //     var _tmp_interval_week = 0;
        //     var interval_week = 0;
        //     var n = 0;
        //     var html = 0;
        //     var video_min_price = this.currencyData.currency_video_min_price;
        //     var _tmp_budget_addition = video_min_price;

        //     let _test_total = 0;

        //     if(_tmp_days > 0){
        //         if(_tmp_days > 3){
        //             n = Math.round(_tmp_days/7);
        //         }
        //     }

        //     //console.log(_tmp_total+'*7');
        //     var first_week = _tmp_total*7;

        //     for(var i = 1; i < n; i++){
        //         var days_pow = i + 1;
        //         // console.log('days_pow:'+days_pow);
        //         // console.log(_tmp_total+' * Math.pow((1 + '+_tmp_budget_addition+'), '+days_pow+') * 7');

        //         //console.log('('+_tmp_total +'+ ('+days_pow+' - 1) * '+_tmp_budget_addition+') * 7');
        //         _tmp_interval_week = (parseInt(_tmp_total) + (parseInt(days_pow) - 1) * parseInt(_tmp_budget_addition)) * 7;

        //         // console.log(interval_week +'='+ interval_week +'+'+ _tmp_interval_week);
        //         interval_week = interval_week + _tmp_interval_week;
        //     }

        //     // console.log(_tmp_total + ' * Math.pow((1 + '+_tmp_budget_addition+'), '+n+') * ('+_tmp_days+' - 7 * '+n+')');

        //     //console.log('('+_tmp_total +'+'+ n +'*'+ _tmp_budget_addition+') * ('+_tmp_days +' - 7 * '+ n+')');
        //     var finish_week = (parseInt(_tmp_total) + parseInt(n) * parseInt(_tmp_budget_addition)) * (parseInt(_tmp_days) - 7 * parseInt(n));

        //     if(_tmp_days > 0 && _tmp_total > 0){
        //         // console.log('Math.round('+first_week +'+'+ interval_week +'+'+ finish_week+')');
        //         html = Math.round(parseInt(first_week) + parseInt(interval_week) + parseInt(finish_week));
        //     }

        //     _test_total = html;

        //     //計算最低預算比率
        //     let _ratio = ((Math.ceil(((parseInt(_test_total) / (parseInt(_tmp_total) * parseInt(_tmp_days))))*100)/100 - 1)*100).toFixed(0);

        //     this.updateMinAddition = _ratio;

        //     if(parseInt(budgetAddition) < parseInt(_ratio)){
        //       // console.log('有結束日期之下，不允許小於:'+_ratio);
        //       this.goalsData.form_addition = _ratio;
        //     } else {
        //       // console.log(budgetAddition +" > "+ _ratio);
        //     }
        //   } else {
        //     // console.log('沒結束日期也沒日期間距');
        //     var _tmp_keyword_split_budget = budgetKW;
        //     var video_min_price = this.currencyData.currency_video_min_price;
        //     var single_ratio = Math.ceil((video_min_price/(parseInt(_tmp_keyword_split_budget)))*100);
        //     if(_tmp_keyword_split_budget == 0){
        //         single_ratio = 0;
        //     }

        //     this.updateMinAddition = single_ratio;

        //     if(parseInt(budgetAddition) < parseInt(single_ratio)){
        //       // console.log('沒結束日期之下，不允許小於:'+single_ratio);
        //       this.goalsData.form_addition = single_ratio;
        //     } else {
        //       // console.log(budgetAddition +" > "+ single_ratio);
        //     }
        //   }

        // } else {
        //   //沒結束日期
        //   // console.log('沒結束日期');
        //   // console.log(this.currencyData.currency_video_min_price);
        //   // console.log(budgetKW);
        //   var _tmp_keyword_split_budget = budgetKW;
        //   var video_min_price = this.currencyData.currency_video_min_price;
        //   var single_ratio = Math.ceil((video_min_price/(parseInt(_tmp_keyword_split_budget)))*100);
        //   if(_tmp_keyword_split_budget == 0){
        //       single_ratio = 0;
        //   }

        //   this.updateMinAddition = single_ratio;

        //   if(budgetAddition < single_ratio){
        //     // console.log('沒結束日期之下，不允許小於:'+single_ratio);
        //     this.goalsData.form_addition = single_ratio;
        //   } else {
        //     // console.log(budgetAddition +" > "+ single_ratio);
        //   }
        // }

        // console.log('update this.updateMinAddition:'+this.updateMinAddition);

        // return 'string form test_call';
      },
      methodTargetKW(value){
        // console.log('methods childTargetKW')
        // console.log(value);
        this.showTargetKW = value
        this.menu[0].submenu[4].show = value

        // if(!this.menu[1].submenu[0].show && !this.menu[1].submenu[1].show){
        //   this.menu[1].show = false
        // } else {
        //   this.menu[1].show = true
        // }
      },
      methodTargetDM(value){
        // console.log('methods childTargetDM')
        // console.log(value);
        this.showTargetDM = value

        if(value == true){
          // if(this.getGoalsObjective == 'CONVERSIONS'){
          //   this.regionsData.age_min = 13;
          //   this.regionsData.age_max = 65;
          // }
          // if(this.getGoalsObjective == 'LINK_CLICKS'){
          //   this.regionsData.age_min = 13;
          //   this.regionsData.age_max = 64;
          // }
          // if(this.getGoalsObjective == 'POST_ENGAGEMENT'){
          //   this.regionsData.age_min = 13;
          //   this.regionsData.age_max = 64;
          // }
          // if(this.getGoalsObjective == 'VIDEO_VIEWS'){
          //   this.regionsData.age_min = 13;
          //   this.regionsData.age_max = 64;
          // }
          // if(this.getGoalsObjective == 'LEAD_GENERATION'){
          //   this.regionsData.age_min = 18;
          //   this.regionsData.age_max = 65;
          // }
          // if(this.getGoalsObjective == 'MESSAGES'){
          //   this.regionsData.age_min = 13;
          //   this.regionsData.age_max = 64;
          // }

          // this.regionsData.age_min = 13;
          this.regionsData.age_max = 65;
        }

        // console.log(this.regionsData);
      },
      methodTargetLA(value){
        // console.log('methods childTargetLA')
        // console.log(value);
        this.showTargetLA = value
        this.menu[0].submenu[5].show = value

        // if(!this.menu[1].submenu[0].show && !this.menu[1].submenu[1].show){
        //   this.menu[1].show = false
        // } else {
        //   this.menu[1].show = true
        // }
      },
      methodTargetAD(value){
        // console.log('methodTargetAD');
        // console.log(value);

        this.showTargetAD = value;
        this.efficientAi = value;

        // this.dateData.end_date = '0000-00-00';
        // console.log('this.dateData.end_date');
        // console.log(this.dateData.end_date);
      },
      methodTargetCR(value){
        console.log('methodTargetCR');
        console.log(value)
        this.showTargetCR = value

        // if(value == true && this.lookData.custom_lookalikes.length <= 0){
        //   console.log('in');
        //   var todayForm = new Date();
        //   var yearForm = todayForm.getFullYear();
        //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
        //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        //   let get_value = 'true_'+yearForm + monthForm + dateForm + timeForm;

        //   this.showAdvertisingMix = get_value;
        //   console.log('axios showAdvertisingMix');
        //   console.log(this.showAdvertisingMix);

        //   axios
        //     .post('https://test.autoturn.net/inside/api/campaign_lookalikes.php', Qs.stringify({
        //       s_code: this.$route.params.id,
        //       adaccount_id: this.$route.params.adaccount_id,
        //       pixel_id: this.goalsData.pixel_id,
        //       product_url: this.productUrl,
        //     }))
        //     .then((response) => {
        //       if(response.data.status == 'success'){

        //         this.lookData = {
        //                           default_lookalikes : response.data.return_data.default_lookalikes,
        //                           custom_lookalikes : response.data.return_data.custom_lookalikes,
        //                           custom_lookalikes_selected : response.data.return_data.custom_lookalikes_selected,
        //                           default_lookalikes_list : response.data.return_data.default_lookalikes_list,
        //                           custom_lookalikes_list : response.data.return_data.custom_lookalikes_list
        //                         }

        //         var todayForm = new Date();
        //         var yearForm = todayForm.getFullYear();
        //         var dateForm = String(todayForm.getDate()).padStart(2, '0');
        //         var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        //         var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        //         let get_value = 'false_'+yearForm + monthForm + dateForm + timeForm;

        //         this.showAdvertisingMix = get_value;
        //       }
        //     });
        // }

        // if(value != true && this.lookData.custom_lookalikes != null) {
        //   this.lookData = {
        //                     default_lookalikes : null,
        //                     custom_lookalikes : null,
        //                     custom_lookalikes_selected : null,
        //                     default_lookalikes_list : null,
        //                     custom_lookalikes_list : null
        //                   }
        // }

        // if(value == true && this.audiencesData.custom_audiences_list.length <= 0){
        //   console.log('in');

        //   var todayForm = new Date();
        //   var yearForm = todayForm.getFullYear();
        //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
        //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        //   let get_value = 'ture_'+yearForm + monthForm + dateForm + timeForm;

        //   this.showRemarketingMix = get_value;

        //   axios
        //     .post('https://test.autoturn.net/inside/api/campaign_audiences.php', Qs.stringify({
        //       s_code: this.$route.params.id,
        //       adaccount_id: this.$route.params.adaccount_id,
        //     }))
        //     .then((response) => {
        //       if(response.data.status == 'success'){

        //         this.audiencesData = {
        //                           default_audiences : response.data.return_data.default_audiences,
        //                           custom_audiences : response.data.return_data.custom_audiences,
        //                           custom_audiences_selected : response.data.return_data.custom_audiences_selected,
        //                           default_audiences_list : response.data.return_data.default_audiences_list,
        //                           custom_audiences_list : response.data.return_data.custom_audiences_list
        //                         }

        //         var todayForm = new Date();
        //         var yearForm = todayForm.getFullYear();
        //         var dateForm = String(todayForm.getDate()).padStart(2, '0');
        //         var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        //         var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        //         let get_value = 'false_'+yearForm + monthForm + dateForm + timeForm;

        //         this.showRemarketingMix = get_value;
        //       }
        //     });
        // }

        // if(value != true && this.audiencesData.custom_audiences != null) {
        //   this.audiencesData = {
        //                     default_audiences : null,
        //                     custom_audiences : null,
        //                     custom_audiences_selected : null,
        //                     default_audiences_list : null,
        //                     custom_audiences_list : null
        //                   }
        // }

        if(value == true){
          if(this.subCampaignList.length <= 0){
            this.menu = [
              {
                title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_title'],
                submenu: [
                  {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_0_title'], show: true, checked: false},
                  {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_1_title'], show: true, checked: false},
                  {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_2_title'], show: true, checked: false},
                  {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_3_title'], show: true, checked: false},
                  {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_4_title'], show: true, checked: false},
                  {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_7_title'], show: true, checked: false},
                  {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_6_title'], show: true, checked: false},
                ],
                open: true,
                show: true,
                target: 1
              },
            ];

            console.log('0 this.stageMenu');
            console.log(this.stageMenu);

            let _tmpMenu = JSON.parse(JSON.stringify(this.menu));
            let _tmpMetaTest = JSON.parse(JSON.stringify(this.stageMenu['USE_TEST']['META_TEST']));
            let _tmpMetaKw = JSON.parse(JSON.stringify(this.stageMenu['USE_TEST']['META_KW']));
            let _tmpMetaLa = JSON.parse(JSON.stringify(this.stageMenu['USE_TEST']['META_LA']));
            let _tmpMetaAsc = JSON.parse(JSON.stringify(this.stageMenu['USE_TEST']['META_RT']));

            _tmpMenu.push(_tmpMetaTest);
            _tmpMenu.push(_tmpMetaKw);
            _tmpMenu.push(_tmpMetaLa);
            _tmpMenu.push(_tmpMetaAsc);

            console.log('1 this.stageMenu');
            console.log(this.stageMenu);

            console.log('b this.menu');
            console.log(this.menu);

            console.log('2 this.stageMenu');
            console.log(this.stageMenu);

            let stageIndex = 1;

            console.log('b _tmpMenu');
            console.log(_tmpMenu);
            console.log('b this.menu');
            console.log(this.menu);

            for(let i = 0; i < _tmpMenu.length; i++){
              console.log('_tmpMenu[1].title');
              console.log(_tmpMenu[1].title);
              if(_tmpMenu[1].title == '測試素材' && i > 1){
                console.log('#1');
                _tmpMenu[i].title = '第'+stageIndex+'階段：'+_tmpMenu[i].title;
                stageIndex++;
              } else if(_tmpMenu[1].title != '測試素材' && i > 0){
                console.log('#2');
                _tmpMenu[i].title = '第'+stageIndex+'階段：'+_tmpMenu[i].title;
                stageIndex++;
              }
              console.log('stageIndex');
              console.log(stageIndex);
            }

            this.menu = _tmpMenu;

            console.log('a _tmpMenu');
            console.log(_tmpMenu);

            console.log('3 this.stageMenu');
            console.log(this.stageMenu);

            console.log('a this.menu');
            console.log(this.menu);

            this.customRulesData = {
              editIndex: 0,
              haveTest: true,
              stageList: [
                { marketingValue: 'META_KW'},
                { marketingValue: 'META_LA'},
                { marketingValue: 'META_RT'}
              ],
              subCampaignsContent: []
            };

            console.log('b this.customRulesData');
            console.log(this.customRulesData);

            let _tmpSubCampaignsContent = [];

            _tmpSubCampaignsContent.push(this.defaultStage['USE_TEST']['META_TEST']);
            _tmpSubCampaignsContent.push(this.defaultStage['USE_TEST']['META_KW']);
            _tmpSubCampaignsContent.push(this.defaultStage['USE_TEST']['META_LA']);
            _tmpSubCampaignsContent.push(this.defaultStage['USE_TEST']['META_RT']);

            for(let i = 0; i < _tmpSubCampaignsContent.length; i++){
              if(_tmpSubCampaignsContent[i].method == 'META_LA'){
                axios
                  .post('https://test.autoturn.net/inside/api/campaign_lookalikes.php', Qs.stringify({
                    s_code: this.$route.params.id,
                    adaccount_id: this.$route.params.adaccount_id,
                    pixel_id: this.goalsData.pixel_id,
                    product_url: this.productUrl,
                  }))
                  .then((response) => {
                    if(response.data.status == 'success'){

                      _tmpSubCampaignsContent[i].lookData.default_lookalikes = response.data.return_data.default_lookalikes;
                      _tmpSubCampaignsContent[i].lookData.custom_lookalikes = response.data.return_data.custom_lookalikes;
                      _tmpSubCampaignsContent[i].lookData.custom_lookalikes_selected = response.data.return_data.custom_lookalikes_selected;
                      _tmpSubCampaignsContent[i].lookData.default_lookalikes_list = response.data.return_data.default_lookalikes_list;
                      _tmpSubCampaignsContent[i].lookData.custom_lookalikes_list = response.data.return_data.custom_lookalikes_list;

                      // this.lookData = {
                      //                   default_lookalikes : response.data.return_data.default_lookalikes,
                      //                   custom_lookalikes : response.data.return_data.custom_lookalikes,
                      //                   custom_lookalikes_selected : response.data.return_data.custom_lookalikes_selected,
                      //                   default_lookalikes_list : response.data.return_data.default_lookalikes_list,
                      //                   custom_lookalikes_list : response.data.return_data.custom_lookalikes_list
                      //                 }

                      var todayForm = new Date();
                      var yearForm = todayForm.getFullYear();
                      var dateForm = String(todayForm.getDate()).padStart(2, '0');
                      var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                      var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                      let get_value_la = 'false_'+yearForm + monthForm + dateForm + timeForm;

                      this.showAdvertisingMix = get_value_la;
                    }
                  });
              }

              if(_tmpSubCampaignsContent[i].method == 'META_RT'){
                axios
                  .post('https://test.autoturn.net/inside/api/campaign_audiences.php', Qs.stringify({
                    s_code: this.$route.params.id,
                    adaccount_id: this.$route.params.adaccount_id,
                  }))
                  .then((response) => {
                    if(response.data.status == 'success'){

                      _tmpSubCampaignsContent[i].audiencesData.default_audiences = response.data.return_data.default_audiences;
                      _tmpSubCampaignsContent[i].audiencesData.custom_audiences = response.data.return_data.custom_audiences;
                      _tmpSubCampaignsContent[i].audiencesData.custom_audiences_selected = response.data.return_data.custom_audiences_selected;
                      _tmpSubCampaignsContent[i].audiencesData.default_audiences_list = response.data.return_data.default_audiences_list;
                      _tmpSubCampaignsContent[i].audiencesData.custom_audiences_list = response.data.return_data.custom_audiences_list;

                      var todayForm = new Date();
                      var yearForm = todayForm.getFullYear();
                      var dateForm = String(todayForm.getDate()).padStart(2, '0');
                      var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                      var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                      let get_value_rt = 'false_'+yearForm + monthForm + dateForm + timeForm;

                      this.showRemarketingMix = get_value_rt;
                    }
                  });
              }
            }

            this.customRulesData.subCampaignsContent = _tmpSubCampaignsContent;

            console.log('a this.customRulesData');
            console.log(this.customRulesData);
          } else {
            if(this._tmpMenu != '' && this._tmpMenu != null){
              this.menu = this._tmpMenu;
            }
          }
        } else {
          this.menu = [
            {
              title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_title'],
              submenu: [
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_0_title'], groupType: 'childCampaignName', refName: 'campaignName', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_1_title'], groupType: 'childMarketingMethod', refName: 'marketingMethod', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_8_title'], groupType: 'childBenefitAndContribution', refName: 'benefitAndContribution', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_2_title'], groupType: 'childAdStrategy', refName: 'adStrategy', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_3_title'], groupType: 'childKeywordMix', refName: 'keywordMix', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_4_title'], groupType: 'childAdvertisingMix', refName: 'advertisingMix', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_7_title'], groupType: 'childRemarketingMix', refName: 'remarketingMix', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_6_title'], groupType: 'childMarketingDate', refName: 'marketingDate', show: true, checked: false},
              ],
              open: true,
              show: true,
              target: 1
            },
            // {
            //   title: '關鍵字與受眾',
            //   submenu: [
            //     {title: '精準興趣關鍵字', show: true, checked: false},
            //     {title: '類似受眾廣告組合', show: true, checked: false},
            //   ],
            //   open: true,
            //   show: true,
            //   target: 2
            // },
            {
              title: this.showLang[this.selectLang]['views']['Event']['menu']['step_2_title'],
              submenu: [
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_2_submenu_1_title'], groupType: 'childGoalsAndBudget', refName: 'goalsAndBudget', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_2_submenu_2_title'], groupType: 'childRegions', refName: 'regions', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_2_submenu_3_title'], groupType: 'childRelationship', refName: 'relationship', show: true, checked: false},
              ],
              open: true,
              show: true,
              target: 2
            },
            {
              title: this.showLang[this.selectLang]['views']['Event']['menu']['step_3_title'],
              submenu: [
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_3_submenu_1_title'], groupType: 'childPositionDevice', refName: 'positionDevice', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_3_submenu_2_title'], groupType: 'childIdentity', refName: 'identity', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_3_submenu_3_title'], groupType: 'childMaterial', refName: 'material', show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_3_submenu_4_title'], groupType: 'childCustomizeMaterial', refName: 'customizeMaterial', show: true, checked: false},
              ],
              open: true,
              show: true,
              target: 3
            },
          ];

          this.menu[0].submenu[4].show = this.showTargetKW
          this.menu[0].submenu[5].show = this.showTargetLA
          this.menu[0].submenu[6].show = this.showTargetRT
        }

        console.log('this.customRulesData');
        console.log(this.customRulesData);

        this.menu[0].submenu[3].show = value
      },
      goalsObjective(value){
        console.log('goalsObjective');
        console.log(value);

        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        let get_value = yearForm + monthForm + dateForm + timeForm;

        this.getGoalsObjective = value

        if(this.showTargetDM == true){
          if(value == 'CONVERSIONS'){
            // this.regionsData.age_min = 13;
            this.regionsData.age_max = 65;
          }
          if(value == 'LINK_CLICKS'){
            // this.regionsData.age_min = 13;
            this.regionsData.age_max = 64;
          }
          if(value == 'POST_ENGAGEMENT'){
            // this.regionsData.age_min = 13;
            this.regionsData.age_max = 64;
          }
          if(value == 'VIDEO_VIEWS'){
            // this.regionsData.age_min = 13;
            this.regionsData.age_max = 64;
          }
          if(value == 'LEAD_GENERATION'){
            // this.regionsData.age_min = 18;
            this.regionsData.age_max = 65;
          }
          if(value == 'MESSAGES'){
            // this.regionsData.age_min = 13;
            this.regionsData.age_max = 64;
          }
        }

        if(value == 'CONVERSIONS'){
          this.showMaterial = true;
          this.showAdvertisingMaterial = false;
          this.showForm = false;
          this.showMsg = false;

          this.showStageMaterial = 'true_'+get_value;
          this.showStageAdvertisingMaterial = 'false_'+get_value;
          this.showStageForm = 'false_'+get_value;
          this.showStageMsg = 'false_'+get_value;

          this.adMaterialData.creative_array = []
        }
        if(value == 'LINK_CLICKS'){
          this.showMaterial = true;
          this.showAdvertisingMaterial = false;
          this.showForm = false;
          this.showMsg = false;

          this.showStageMaterial = 'true_'+get_value;
          this.showStageAdvertisingMaterial = 'false_'+get_value;
          this.showStageForm = 'false_'+get_value;
          this.showStageMsg = 'false_'+get_value;

          this.adMaterialData.creative_array = []
        }
        if(value == 'POST_ENGAGEMENT'){
          this.showMaterial = true;
          this.showAdvertisingMaterial = false;
          this.showForm = false;
          this.showMsg = false;

          this.showStageMaterial = 'true_'+get_value;
          this.showStageAdvertisingMaterial = 'false_'+get_value;
          this.showStageForm = 'false_'+get_value;
          this.showStageMsg = 'false_'+get_value;

          this.adMaterialData.creative_array = []
        }
        if(value == 'VIDEO_VIEWS'){
          this.showMaterial = true;
          this.showAdvertisingMaterial = false;
          this.showForm = false;
          this.showMsg = false;

          this.showStageMaterial = 'true_'+get_value;
          this.showStageAdvertisingMaterial = 'false_'+get_value;
          this.showStageForm = 'false_'+get_value;
          this.showStageMsg = 'false_'+get_value;

          this.adMaterialData.creative_array = []
        }
        if(value == 'LEAD_GENERATION'){
          this.showMaterial = false;
          this.showAdvertisingMaterial = true;
          this.showForm = true;
          this.showMsg = false;

          this.showStageMaterial = 'false_'+get_value;
          this.showStageAdvertisingMaterial = 'true_'+get_value;
          this.showStageForm = 'true_'+get_value;
          this.showStageMsg = 'false_'+get_value;

          // if(this.adMaterialData.creative_array == null){
          //   this.adMaterialData.creative_array = [
          //     {
          //       title: "xxxx",
          //       isEdit: false,
          //       type: 1,
          //       materials:[],
          //       materialSingle: [
          //         {
          //           src: null,
          //           title: null,
          //           size: null
          //         }
          //       ],
          //       callActive: 'SIGN_UP'
          //     }
          //   ]
          // }
        }
        if(value == 'MESSAGES'){
          this.showMaterial = true;
          this.showAdvertisingMaterial = true;
          this.showForm = false;
          this.showMsg = true;

          this.showStageMaterial = 'true_'+get_value;
          this.showStageAdvertisingMaterial = 'true_'+get_value;
          this.showStageForm = 'false_'+get_value;
          this.showStageMsg = 'true_'+get_value;

          // if(this.adMaterialData.creative_array == null){
          //   this.adMaterialData.creative_array = [
          //     {
          //       title: "xxxx",
          //       isEdit: false,
          //       type: 1,
          //       materials:[],
          //       materialSingle: [
          //         {
          //           src: null,
          //           title: null,
          //           size: null
          //         }
          //       ],
          //       callActive: 'SIGN_UP'
          //     }
          //   ]
          // }
        }

        if(value == 'PRODUCT_CATALOG_SALES'){
          this.showMaterial = true;
          this.showAdvertisingMaterial = false;
          this.showForm = false;
          this.showMsg = false;

          this.showStageMaterial = 'true_'+get_value;
          this.showStageAdvertisingMaterial = 'false_'+get_value;
          this.showStageForm = 'false_'+get_value;
          this.showStageMsg = 'false_'+get_value;

          this.postData.select_article = [];
          this.postData.select_creatives = [];
        } else {
          this.postData.select_creatives_adset_ads = [];
        }

        this.adMaterialDataNew = this.tmpAdMaterialDataNew

        // console.log('this.showMaterial:'+this.showMaterial);
        // console.log('this.showAdvertisingMaterial:'+this.showAdvertisingMaterial);
        // console.log('this.showForm:'+this.showForm);
        // console.log('this.showMsg:'+this.showMsg);

        console.log('goalsObjective this.adMaterialDataNew');
        console.log(this.adMaterialDataNew);
      },
      getHere(target, refName, groupType){
        console.log('getHere', target, refName, groupType, this.menu);
        this.target = target

        // if(this.menu[1].show == false){
        //   if (target > 1) {
        //     target -= 1
        //   }
        //   this.process = parseInt(33) * (parseInt(target) - parseInt(1))
        // } else {
        //   this.process = parseInt(25) * (parseInt(target) - parseInt(1))
        // }

        this.process = parseInt(33) * (parseInt(target) - parseInt(1))

        this.$nextTick(() => {
          if(typeof groupType !== 'undefined'){
            let childComponent = this.$refs.childCampaignName;
            if(groupType === 'childMarketingMethod'){
              childComponent = this.$refs.childMarketingMethod;
            }
            if(groupType === 'childBenefitAndContribution'){
              childComponent = this.$refs.childBenefitAndContribution;
            }
            if(groupType === 'childAdStrategy'){
              childComponent = this.$refs.childAdStrategy;
            }
            if(groupType === 'childKeywordMix'){
              childComponent = this.$refs.childKeywordMix;
            }
            if(groupType === 'childAdvertisingMix'){
              childComponent = this.$refs.childAdvertisingMix;
            }
            if(groupType === 'childRemarketingMix'){
              childComponent = this.$refs.childRemarketingMix;
            }
            if(groupType === 'childMarketingDate'){
              childComponent = this.$refs.childMarketingDate;
            }
            if(groupType === 'childGoalsAndBudget'){
              childComponent = this.$refs.childGoalsAndBudget;
            }
            if(groupType === 'childRegions'){
              childComponent = this.$refs.childRegions;
            }
            if(groupType === 'childRelationship'){
              childComponent = this.$refs.childRelationship;
            }
            if(groupType === 'childPositionDevice'){
              childComponent = this.$refs.childPositionDevice;
            }
            if(groupType === 'childIdentity'){
              childComponent = this.$refs.childIdentity;
            }
            if(groupType === 'childMaterial'){
              childComponent = this.$refs.childMaterial;
            }
            if(groupType === 'childCustomizeMaterial'){
              childComponent = this.$refs.childCustomizeMaterial;
            }
            console.log('childComponent', childComponent);
            if (childComponent && childComponent.$refs[refName]) {
              console.log('移動');
              childComponent.$refs[refName].scrollIntoView({ behavior: "smooth", block: "start" });
            }
          }
        });

        document.getElementById('edit_content').scrollTop = 0;
      },
      eventPageId(value) {
        // console.log('methods eventPageId')
        // console.log(value);
        this.formPageId = value
      },
      eventFormId(value) {
        // console.log('methods eventFormId')
        // console.log(value);
        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        let get_value = value+'_'+yearForm + monthForm + dateForm + timeForm;
        if(value != '' && value != null && typeof value != 'undefined'){
          this.formId = get_value
        } else {
          this.formId = []
        }
      },
      eventMessageId(value) {
        // console.log('methods eventMessageId')
        // console.log(value);
        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        let get_value = value+'_'+yearForm + monthForm + dateForm + timeForm;
        if(value != '' && value != null && typeof value != 'undefined'){
          this.messageId = get_value
        } else {
          this.messageId = []
        }
      },
      materialChange(value){
        console.log('老爸知道有變動 materialChange')
        console.log(value);
        this.isChangeDataMaterial = value
      },
      adMaterialChange(value){
        console.log('adMaterialChange')
        console.log(value);
        this.isChangeDataAdMaterial = value
      },
      adMaterialContent(value){
        console.log('adMaterialContent')
        console.log(value);
        if(typeof value.creative_array != 'undefined'){
          this.adMaterialDataNew = value
        } else {
          this.adMaterialDataNew.creative_array = value
        }
      },
      formChangeFormId(value){
        console.log('formChangeFormId')
        console.log(value);

        this.changeFormId = value
      },
      activeScroll(value){

        let tmpDataType = value.split('_');

        if(tmpDataType[0] == 1){
          this.$refs.scrollcontent.scrollTo({
            top: 1505,
            behavior: 'smooth'
          });
        }
      },
      prev() {
        // console.log('now target:'+this.target);
        // if(this.menu[1].show == false){
          this.process -= 33
          if (this.target > 1) {
            this.target -= 1

            // if(this.target == 2){
            //   this.target -= 1
            // }
          }
        // } else {
        //   this.process -= 25
        //   if (this.target > 1) {
        //     this.target -= 1
        //   }
        // }
        // console.log('prev target:'+this.target);
        document.getElementById('edit_content').scrollTop = 0;
      },
      next() {
        // console.log('now target:'+this.target);
        // if(this.menu[1].show == false){
          this.process += 33
          // console.log('now target:'+this.target);
          if (this.target <= 3) {
            this.target += 1
            this.menu[this.target-1].open = true
          }
          // if(this.target == 2){
          //   this.target += 1
          // }
        // } else {
        //   this.process += 25
        //   // console.log('now target:'+this.target);
        //   if (this.target <= 4) {
        //     this.target += 1
        //     this.menu[this.target-1].open = true
        //   }
        //   // console.log('next target:'+this.target);
        // }
        // console.log('next target:'+this.target);
        document.getElementById('edit_content').scrollTop = 0;
      },
      form_update(){
        // console.log('form_update');

        // console.log('this.postData');
        // console.log(this.postData);
        // console.log('this.adMaterialDataNew');
        // console.log(this.adMaterialDataNew);

        if(this.methodData.Target_CR == true || this.methodData.Other_Target_CR == true || this.useDefaultLayout !== null){
          console.log('自定義儲存');
          this.customizeSave();
        } else {
          console.log('非自定義儲存');
          let error = 0;

          // if((this.goalsData.risk_level.code == 'auto' || this.goalsData.risk_level.code == 'low') && (this.goalsData.effect == '' || this.goalsData.effect == 0 || this.goalsData.effect == null)){
          if(this.goalsData.effect == '' || this.goalsData.effect == 0 || this.goalsData.effect == null){
            Swal.fire(
                      this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['empty_effect_swal_title'],
                      this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['empty_effect_swal_text'],
                      "warning"
                    )

            error = 1;
          }

          console.log('1 error');
          console.log(error);

          console.log('this.goalsData.campaign_objective');
          console.log(this.goalsData.campaign_objective);

          if(this.goalsData.campaign_objective == 'CONVERSIONS' || this.goalsData.campaign_objective == 'LINK_CLICKS' || this.goalsData.campaign_objective == 'POST_ENGAGEMENT' || this.goalsData.campaign_objective == 'VIDEO_VIEWS'){

            let select_article_length = 0;
            if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
              select_article_length = this.postData.select_article.length;
            }

            let select_creatives_length = 0;
            if(this.postData.select_creatives != '' && this.postData.select_creatives != null && typeof this.postData.select_creatives != 'undefined'){
              select_creatives_length = this.postData.select_creatives.length;
            }

            let select_creatives_adset_ads_length = 0;
            if(this.postData.select_creatives_adset_ads != '' && this.postData.select_creatives_adset_ads != null && typeof this.postData.select_creatives_adset_ads != 'undefined'){
              select_creatives_adset_ads_length = this.postData.select_creatives_adset_ads.length;
            }

            console.log('select_article_length');
            console.log(select_article_length);

            console.log('select_creatives_length');
            console.log(select_creatives_length);

            console.log('select_creatives_adset_ads_length');
            console.log(select_creatives_adset_ads_length);

            if(select_article_length <= 0 && select_creatives_length <= 0 && select_creatives_adset_ads_length <= 0){
              error = 1;

              Swal.fire(
                this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['empty_select_article_swal_title'],
                this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['empty_select_article_swal_text'],
                'error'
              )
            }
          }

          console.log('2 error');
          console.log(error);

          console.log('this.adMaterialDataNew');
          console.log(this.adMaterialDataNew);

          if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
            let materialType = 0;
            let selectArticleLength = 0;
            if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
              selectArticleLength = this.postData.select_article.length;
            }

            let selectCreativesMessageLength = 0;
            if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
              selectCreativesMessageLength = this.postData.select_creatives_message.length;
            }

            let selectCreativesAdsetAdsMessageLength = 0;
            if(this.postData.select_creatives_adset_ads_message != '' && this.postData.select_creatives_adset_ads_message != null && typeof this.postData.select_creatives_adset_ads_message != 'undefined'){
              selectCreativesAdsetAdsMessageLength = this.postData.select_creatives_adset_ads_message.length;
            }

            let creativeArrayLength = 0;
            if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
              creativeArrayLength = this.adMaterialDataNew.creative_array.length;
            }

            if(creativeArrayLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
              materialType = 1;
            } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && selectCreativesAdsetAdsMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
              materialType = 2;
            }

            if(materialType != 0){
              error = 1;

              Swal.fire(
                this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['empty_creative_array_swal_title'],
                this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['empty_creative_array_swal_text'],
                'error'
              )
            }
          }

          console.log('3 error');
          console.log(error);

          console.log('this.showLang');
          console.log(this.showLang);
          console.log('#1 this.selectLang');
          console.log(this.selectLang);
          console.log("this.showLang[this.selectLang]['views']['EventBrowse']");
          console.log(this.showLang[this.selectLang]['views']['EventBrowse']);

          if(error == 0){
            let member_hash = this.$route.params.id
            let adaccount_id = this.$route.params.adaccount_id

            console.log('#2 this.selectLang');
            console.log(this.selectLang);

            let _tmp_showLang = this.showLang
            let _tmp_selectLang = this.selectLang

            axios
              .post('https://test.autoturn.net/inside/api/campaign_member_status.php', Qs.stringify({
                s_code: member_hash,
                route_type: this.$route.params.type,
                active: 'member',
              }))
              .then((caResponse) => {
                console.log('#3 this.selectLang');
                console.log(this.selectLang);

                if(caResponse.data.status == 'error'){
                  if(caResponse.data.type == 2){
                    Swal.fire({
                      icon: caResponse.data.status,
                      title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['error']['swal_title'],
                      text: caResponse.data.info,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['error']['confirm_button']
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        this.allPageLoading = true
                        window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        this.allPageLoading = true
                        window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                      }
                    })
                  } else if(caResponse.data.type == 3){
                    Swal.fire({
                      icon: caResponse.data.status,
                      title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['error']['swal_title'],
                      text: caResponse.data.info,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['error']['confirm_button']
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        this.allPageLoading = true
                        window.location.href = "https://dev-private.autoturn.net/f/"+member_hash;
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        this.allPageLoading = true
                        window.location.href = "https://dev-private.autoturn.net/f/"+member_hash;
                      }
                    })
                  } else {
                    Swal.fire(
                              this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['error']['swal_title'],
                              caResponse.data.info,
                              caResponse.data.status
                            )
                  }
                }

                if(caResponse.data.status == 'warning'){
                  Swal.fire({
                    icon: 'warning',
                    title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['swal_title'],
                    text: caResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    let formData = {
                      campaign_id: this.campaign_id,
                      adaccount_id: this.adaccount_id,
                      idData: this.idData,
                      regionsData: this.regionsData,
                      goalsData: this.goalsData,
                      isChangeDataMaterial: this.isChangeDataMaterial,
                      postData: this.postData,
                      isChangeDataAdMaterial: this.isChangeDataAdMaterial,
                      adMaterialData: this.adMaterialDataNew
                    }

                    let member_hash = this.$route.params.id
                    let adaccount_id = this.adaccount_id
                    let campaign_id = this.campaign_id

                    console.log('warning this.isChangeDataMaterial');
                    console.log(this.isChangeDataMaterial);
                    console.log('this.isChangeDataAdMaterial');
                    console.log(this.isChangeDataAdMaterial);

                    axios
                      .post('https://test.autoturn.net/inside/api/data/campaign_browse_update.php', Qs.stringify({
                        s_code: member_hash,
                        form_data: formData,
                      }))
                      .then((response) => {
                        // console.log(response.data);
                        if(response.data.status == 'success'){
                          if(this.isChangeDataMaterial == true){
                            //post_task
                            console.log('post_task');
                            if(response.data.post_task != '' && response.data.post_task != null && typeof(response.data.post_task) != 'undefined'){
                              var status = 1;
                              this.releaseType = true
                              this.style = 'z-index:100;';
                              console.log('releaseType');
                              var bar5 = new ldBar("#myItem5");
                              bar5.set(this.releasePercent);
                              setInterval( () => {
                                  if(status == 1){
                                    console.log('status');
                                    console.log(status);
                                    axios
                                      .post('https://test.autoturn.net/inside/api/campaign_task.php', Qs.stringify({
                                        s_code: member_hash,
                                        id: response.data.post_task,
                                      }))
                                      .then((taskResponse) => {
                                        // console.log('post_task');
                                        // console.log(taskResponse.data);
                                        if(taskResponse.data.return_data.state == 'SUCCESS' && taskResponse.data.return_data.info_state == 'FAILURE'){
                                          status = 0;
                                          Swal.fire({
                                            icon: 'error',
                                            title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['material']['info_state_failure']['swal_title'],
                                            text: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['material']['info_state_failure']['swal_text']+taskResponse.data.return_data.current,
                                            showDenyButton: false,
                                            showCancelButton: false,
                                            confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['material']['info_state_failure']['confirm_button'],
                                            // timer: 5000
                                            // denyButtonText: `Don't save`,
                                          }).then((result) => {
                                            this.releaseType = false
                                            this.style = 'z-index:-1;';
                                            this.releasePercent = 5;
                                            /* Read more about isConfirmed, isDenied below */
                                            // if (result.isConfirmed) {
                                            //   // Swal.fire('Saved!', '', 'success')
                                            //   this.showCampaignData = true
                                            //   window.location.href = "https://dev-private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                            // } else if (result.isDenied) {
                                            //   // Swal.fire('Changes are not saved', '', 'info')
                                            //   this.showCampaignData = true
                                            //   window.location.href = "https://dev-private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                            // }

                                            // if (result.dismiss === Swal.DismissReason.timer) {
                                            //   this.showCampaignData = true
                                            //   window.location.href = "https://dev-private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                            // }
                                          })
                                        } else if(taskResponse.data.return_data.state == 'SUCCESS' && taskResponse.data.return_data.info_state == 'SUCCESS'){
                                          status = 0;
                                          axios
                                            .post('https://test.autoturn.net/inside/api/data/campaign_view_creatives_update.php', Qs.stringify({
                                              s_code: member_hash,
                                              id: campaign_id,
                                            }))
                                            .then((response) => {
                                              Swal.fire({
                                                icon: 'success',
                                                title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['material']['info_state_success']['swal_title'],
                                                text: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['material']['info_state_success']['swal_text'],
                                                title: '確認修改',/*
                                                text: '修改完成，5秒後將為您導回列表頁。',*/
                                                showDenyButton: false,
                                                showCancelButton: false,
                                                confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['material']['info_state_success']['confirm_button'],
                                                // confirmButtonText: '確定',
                                                timer: 5000
                                                // denyButtonText: `Don't save`,
                                              }).then((result) => {
                                                /* Read more about isConfirmed, isDenied below */
                                                if (result.isConfirmed) {
                                                  // Swal.fire('Saved!', '', 'success')
                                                  this.showCampaignData = true
                                                  window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                } else if (result.isDenied) {
                                                  // Swal.fire('Changes are not saved', '', 'info')
                                                  this.showCampaignData = true
                                                  window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                }

                                                if (result.dismiss === Swal.DismissReason.timer) {
                                                  this.showCampaignData = true
                                                  window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                }
                                              })
                                            });
                                        } else {
                                          this.releasePercent = taskResponse.data.return_data.pct

                                          bar5.set(this.releasePercent);

                                          if(taskResponse.data.return_data.pct == 100){
                                            this.releaseType = false
                                            this.style = 'z-index:-1;';
                                            this.releasePercent = 5;
                                            status = 0;
                                          }
                                        }

                                        // console.log('taskResponse.data.return_data.state:'+taskResponse.data.return_data.state);
                                        // console.log('taskResponse.data.return_data.current:'+taskResponse.data.return_data.current);
                                        // console.log('taskResponse.data.return_data.pct:'+taskResponse.data.return_data.pct);
                                        // console.log('taskResponse.data.return_data.info_state:'+taskResponse.data.return_data.info_state);
                                      });
                                  }
                                }, 3000);
                            }

                          } else if(this.isChangeDataAdMaterial == true){
                            //creatives_task
                            console.log('creatives_task');
                            if(response.data.creatives_task != '' && response.data.creatives_task != null && typeof(response.data.creatives_task) != 'undefined'){
                              var status = 1;
                              this.releaseType = true
                              this.style = 'z-index:100;';
                              console.log('releaseType');
                              var bar5 = new ldBar("#myItem5");
                              bar5.set(this.releasePercent);
                              setInterval( () => {
                                  if(status == 1){
                                    console.log('status');
                                    console.log(status);
                                    axios
                                      .post('https://test.autoturn.net/inside/api/campaign_task.php', Qs.stringify({
                                        s_code: member_hash,
                                        id: response.data.creatives_task,
                                      }))
                                      .then((taskResponse) => {
                                        // console.log('creatives_task');
                                        // console.log(taskResponse.data);
                                        if(taskResponse.data.return_data.state == 'SUCCESS' && taskResponse.data.return_data.info_state == 'FAILURE'){
                                          status = 0;
                                          Swal.fire({
                                            icon: 'error',
                                            title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['ad_material']['info_state_failure']['swal_title'],
                                            text: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['ad_material']['info_state_failure']['swal_text']+taskResponse.data.return_data.current,
                                            showDenyButton: false,
                                            showCancelButton: false,
                                            confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['ad_material']['info_state_failure']['confirm_button'],
                                            // timer: 5000
                                            // denyButtonText: `Don't save`,
                                          }).then((result) => {
                                            this.releaseType = false
                                            this.style = 'z-index:-1;';
                                            this.releasePercent = 5;
                                            /* Read more about isConfirmed, isDenied below */
                                            // if (result.isConfirmed) {
                                            //   // Swal.fire('Saved!', '', 'success')
                                            //   this.showCampaignData = true
                                            //   window.location.href = "https://dev-private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                            // } else if (result.isDenied) {
                                            //   // Swal.fire('Changes are not saved', '', 'info')
                                            //   this.showCampaignData = true
                                            //   window.location.href = "https://dev-private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                            // }

                                            // if (result.dismiss === Swal.DismissReason.timer) {
                                            //   this.showCampaignData = true
                                            //   window.location.href = "https://dev-private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                            // }
                                          })
                                        } else if(taskResponse.data.return_data.state == 'SUCCESS' && taskResponse.data.return_data.info_state == 'SUCCESS'){
                                          status = 0;
                                          Swal.fire({
                                            icon: 'success',
                                            title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['ad_material']['info_state_success']['swal_title'],
                                            text: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['ad_material']['info_state_success']['swal_text'],
                                            // title: '確認修改',
                                            // text: '修改完成，5秒後將為您導回列表頁。',
                                            showDenyButton: false,
                                            showCancelButton: false,
                                            confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['ad_material']['info_state_success']['confirm_button'],
                                            // confirmButtonText: '確定',
                                            timer: 5000
                                            // denyButtonText: `Don't save`,
                                          }).then((result) => {
                                            /* Read more about isConfirmed, isDenied below */
                                            if (result.isConfirmed) {
                                              // Swal.fire('Saved!', '', 'success')
                                              this.showCampaignData = true
                                              window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                            } else if (result.isDenied) {
                                              // Swal.fire('Changes are not saved', '', 'info')
                                              this.showCampaignData = true
                                              window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                            }

                                            if (result.dismiss === Swal.DismissReason.timer) {
                                              this.showCampaignData = true
                                              window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                            }
                                          })
                                        } else {
                                          this.releasePercent = taskResponse.data.return_data.pct

                                          bar5.set(this.releasePercent);

                                          if(taskResponse.data.return_data.pct == 100){
                                            this.releaseType = false
                                            this.style = 'z-index:-1;';
                                            this.releasePercent = 5;
                                            status = 0;
                                          }
                                        }

                                        // console.log('taskResponse.data.return_data.state:'+taskResponse.data.return_data.state);
                                        // console.log('taskResponse.data.return_data.current:'+taskResponse.data.return_data.current);
                                        // console.log('taskResponse.data.return_data.pct:'+taskResponse.data.return_data.pct);
                                        // console.log('taskResponse.data.return_data.info_state:'+taskResponse.data.return_data.info_state);
                                      });
                                  }
                                }, 3000);
                            }
                          } else {
                            Swal.fire({
                              icon: 'success',
                              title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['not_material']['swal_title'],
                              text: response.data.info,
                              showDenyButton: false,
                              showCancelButton: false,
                              confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['not_material']['confirm_button'],
                              // denyButtonText: `Don't save`,
                            }).then((result) => {
                              /* Read more about isConfirmed, isDenied below */
                              // if (result.isConfirmed) {
                                // Swal.fire('Saved!', '', 'success')

                                window.location.href = "https://dev-private.autoturn.net/events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                              // } else if (result.isDenied) {
                                // Swal.fire('Changes are not saved', '', 'info')
                              // }
                            })
                          }

                          // this.immediateList = response.data.return_data
                          // this.formData = response.data.return_data.form

                          // if(type == 1){
                          //   var todayForm = new Date();
                          //   var yearForm = todayForm.getFullYear();
                          //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                          //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                          //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                          //   todayForm = yearForm + monthForm + dateForm + timeForm;

                          //   this.formTitle = 'title_'+todayForm;
                          // } else {
                          //   this.formTitle = response.data.return_data.name;
                          // }

                          // this.showModal = true
                        } else {
                          let text = this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['update_not_success_default_swal_text'];
                          if(response.data.info != '' && response.data.info != null){
                            text = response.data.info
                          }
                          Swal.fire(
                            this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['update_not_success_swal_title'],
                            'error'
                          )
                        }
                      });
                  });
                }

                if(caResponse.data.status == 'success'){
                  console.log('#4 this.selectLang');
                  console.log(this.selectLang);

                  let formData = {
                    campaign_id: this.campaign_id,
                    adaccount_id: this.adaccount_id,
                    idData: this.idData,
                    regionsData: this.regionsData,
                    goalsData: this.goalsData,
                    isChangeDataMaterial: this.isChangeDataMaterial,
                    postData: this.postData,
                    isChangeDataAdMaterial: this.isChangeDataAdMaterial,
                    adMaterialData: this.adMaterialDataNew
                  }

                  let member_hash = this.$route.params.id
                  let adaccount_id = this.adaccount_id
                  let campaign_id = this.campaign_id

                  console.log('success this.isChangeDataMaterial');
                  console.log(this.isChangeDataMaterial);
                  console.log('this.isChangeDataAdMaterial');
                  console.log(this.isChangeDataAdMaterial);

                  axios
                    .post('https://test.autoturn.net/inside/api/data/campaign_browse_update.php', Qs.stringify({
                      s_code: member_hash,
                      form_data: formData,
                    }))
                    .then((response) => {
                      // console.log(response.data);
                      console.log('#5 this.selectLang');
                      console.log(this.selectLang);

                      if(response.data.status == 'success'){
                        if(this.isChangeDataMaterial == true){
                          //post_task
                          console.log('post_task');
                          console.log('#6 this.selectLang');
                          console.log(this.selectLang);
                          if(response.data.post_task != '' && response.data.post_task != null && typeof(response.data.post_task) != 'undefined'){
                            var status = 1;
                            this.releaseType = true;
                            this.style = 'z-index:100;';
                            console.log('releaseType');
                            console.log(this.releaseType);
                            var bar5 = new ldBar("#myItem5");
                            bar5.set(this.releasePercent);
                            setInterval( () => {
                                if(status == 1){
                                  console.log(status);
                                  console.log('#7 this.selectLang');
                                  console.log(this.selectLang);
                                  console.log('#7 _tmp_showLang');
                                  console.log(_tmp_showLang);
                                  axios
                                    .post('https://test.autoturn.net/inside/api/campaign_task.php', Qs.stringify({
                                      s_code: member_hash,
                                      id: response.data.post_task,
                                    }))
                                    .then((taskResponse) => {
                                      console.log('#8 this.selectLang');
                                      console.log(this.selectLang);
                                      console.log('#8 _tmp_showLang');
                                      console.log(_tmp_showLang);
                                      // console.log('post_task');
                                      // console.log(taskResponse.data);
                                      if(taskResponse.data.return_data.state == 'SUCCESS' && taskResponse.data.return_data.info_state == 'FAILURE'){
                                        status = 0;
                                        this.releaseType = false;
                                        this.style = 'z-index:-1;';
                                        this.releasePercent = 5;
                                        console.log('完成但出錯');
                                        console.log('releaseType');
                                        console.log(this.releaseType);
                                        Swal.fire({
                                          icon: 'error',
                                          title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['material']['info_state_failure']['swal_title'],
                                          text: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['material']['info_state_failure']['swal_text']+taskResponse.data.return_data.current,
                                          showDenyButton: false,
                                          showCancelButton: false,
                                          confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['material']['info_state_failure']['confirm_button'],
                                          // timer: 5000
                                          // denyButtonText: `Don't save`,
                                        }).then((result) => {
                                          /* Read more about isConfirmed, isDenied below */
                                          // if (result.isConfirmed) {
                                          //   // Swal.fire('Saved!', '', 'success')
                                          //   this.showCampaignData = true
                                          //   window.location.href = "https://dev-private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                          // } else if (result.isDenied) {
                                          //   // Swal.fire('Changes are not saved', '', 'info')
                                          //   this.showCampaignData = true
                                          //   window.location.href = "https://dev-private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                          // }

                                          // if (result.dismiss === Swal.DismissReason.timer) {
                                          //   this.showCampaignData = true
                                          //   window.location.href = "https://dev-private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                          // }
                                        })
                                      } else if(taskResponse.data.return_data.state == 'SUCCESS' && taskResponse.data.return_data.info_state == 'SUCCESS'){
                                        status = 0;
                                        axios
                                          .post('https://test.autoturn.net/inside/api/data/campaign_view_creatives_update.php', Qs.stringify({
                                            s_code: member_hash,
                                            id: campaign_id,
                                          }))
                                          .then((response) => {
                                            Swal.fire({
                                              icon: 'success',
                                              title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['material']['info_state_success']['swal_title'],
                                              text: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['material']['info_state_success']['swal_text'],
                                              // title: '確認修改',
                                              // text: '修改完成，5秒後將為您導回列表頁。',
                                              showDenyButton: false,
                                              showCancelButton: false,
                                              confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['material']['info_state_success']['confirm_button'],
                                              // confirmButtonText: '確定',
                                              timer: 5000
                                              // denyButtonText: `Don't save`,
                                            }).then((result) => {
                                              /* Read more about isConfirmed, isDenied below */
                                              if (result.isConfirmed) {
                                                // Swal.fire('Saved!', '', 'success')
                                                this.showCampaignData = true
                                                window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                              } else if (result.isDenied) {
                                                // Swal.fire('Changes are not saved', '', 'info')
                                                this.showCampaignData = true
                                                window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                              }

                                              if (result.dismiss === Swal.DismissReason.timer) {
                                                this.showCampaignData = true
                                                window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                              }
                                            })
                                          });
                                      } else {
                                        this.releasePercent = taskResponse.data.return_data.pct

                                        bar5.set(this.releasePercent);

                                        if(taskResponse.data.return_data.pct == 100){
                                          this.releaseType = false
                                          this.style = 'z-index:-1;';
                                          this.releasePercent = 5;
                                          status = 0;
                                        }
                                      }

                                      // console.log('taskResponse.data.return_data.state:'+taskResponse.data.return_data.state);
                                      // console.log('taskResponse.data.return_data.current:'+taskResponse.data.return_data.current);
                                      // console.log('taskResponse.data.return_data.pct:'+taskResponse.data.return_data.pct);
                                      // console.log('taskResponse.data.return_data.info_state:'+taskResponse.data.return_data.info_state);
                                    });
                                }
                              }, 3000);
                          }

                        } else if(this.isChangeDataAdMaterial == true){
                          //creatives_task
                          console.log('creatives_task');
                          if(response.data.creatives_task != '' && response.data.creatives_task != null && typeof(response.data.creatives_task) != 'undefined'){
                            var status = 1;
                            this.releaseType = true
                            this.style = 'z-index:100;';
                            console.log('releaseType');
                            var bar5 = new ldBar("#myItem5");
                            bar5.set(this.releasePercent);
                            setInterval( () => {
                                if(status == 1){
                                  console.log('status');
                                  console.log(status);
                                  axios
                                    .post('https://test.autoturn.net/inside/api/campaign_task.php', Qs.stringify({
                                      s_code: member_hash,
                                      id: response.data.creatives_task,
                                    }))
                                    .then((taskResponse) => {
                                      // console.log('creatives_task');
                                      // console.log(taskResponse.data);
                                      if(taskResponse.data.return_data.state == 'SUCCESS' && taskResponse.data.return_data.info_state == 'FAILURE'){
                                        status = 0;
                                        Swal.fire({
                                          icon: 'error',
                                          title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['ad_material']['info_state_failure']['swal_title'],
                                          text: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['ad_material']['info_state_failure']['swal_text']+taskResponse.data.return_data.current,
                                          showDenyButton: false,
                                          showCancelButton: false,
                                          confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['ad_material']['info_state_failure']['confirm_button'],
                                          // timer: 5000
                                          // denyButtonText: `Don't save`,
                                        }).then((result) => {
                                          this.releaseType = false
                                          this.style = 'z-index:-1;';
                                          this.releasePercent = 5;
                                          /* Read more about isConfirmed, isDenied below */
                                          // if (result.isConfirmed) {
                                          //   // Swal.fire('Saved!', '', 'success')
                                          //   this.showCampaignData = true
                                          //   window.location.href = "https://dev-private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                          // } else if (result.isDenied) {
                                          //   // Swal.fire('Changes are not saved', '', 'info')
                                          //   this.showCampaignData = true
                                          //   window.location.href = "https://dev-private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                          // }

                                          // if (result.dismiss === Swal.DismissReason.timer) {
                                          //   this.showCampaignData = true
                                          //   window.location.href = "https://dev-private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                          // }
                                        })
                                      } else if(taskResponse.data.return_data.state == 'SUCCESS' && taskResponse.data.return_data.info_state == 'SUCCESS'){
                                        status = 0;
                                        Swal.fire({
                                          icon: 'success',
                                          title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['ad_material']['info_state_success']['swal_title'],
                                          text: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['ad_material']['info_state_success']['swal_text'],
                                          // title: '確認修改',
                                          // text: '修改完成，5秒後將為您導回列表頁。',
                                          showDenyButton: false,
                                          showCancelButton: false,
                                          confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['ad_material']['info_state_success']['confirm_button'],
                                          // confirmButtonText: '確定',
                                          timer: 5000
                                          // denyButtonText: `Don't save`,
                                        }).then((result) => {
                                          /* Read more about isConfirmed, isDenied below */
                                          if (result.isConfirmed) {
                                            // Swal.fire('Saved!', '', 'success')
                                            this.showCampaignData = true
                                            window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                          } else if (result.isDenied) {
                                            // Swal.fire('Changes are not saved', '', 'info')
                                            this.showCampaignData = true
                                            window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                          }

                                          if (result.dismiss === Swal.DismissReason.timer) {
                                            this.showCampaignData = true
                                            window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                          }
                                        })
                                      } else {
                                        this.releasePercent = taskResponse.data.return_data.pct

                                        bar5.set(this.releasePercent);

                                        if(taskResponse.data.return_data.pct == 100){
                                          this.releaseType = false
                                          this.style = 'z-index:-1;';
                                          this.releasePercent = 5;
                                          status = 0;
                                        }
                                      }

                                      // console.log('taskResponse.data.return_data.state:'+taskResponse.data.return_data.state);
                                      // console.log('taskResponse.data.return_data.current:'+taskResponse.data.return_data.current);
                                      // console.log('taskResponse.data.return_data.pct:'+taskResponse.data.return_data.pct);
                                      // console.log('taskResponse.data.return_data.info_state:'+taskResponse.data.return_data.info_state);
                                    });
                                }
                              }, 3000);
                          }
                        } else {
                          Swal.fire({
                            icon: 'success',
                            title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['not_material']['swal_title'],
                            text: response.data.info,
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['not_material']['confirm_button'],
                            // denyButtonText: `Don't save`,
                          }).then((result) => {
                            /* Read more about isConfirmed, isDenied below */
                            // if (result.isConfirmed) {
                              // Swal.fire('Saved!', '', 'success')

                              window.location.href = "https://dev-private.autoturn.net/events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                            // } else if (result.isDenied) {
                              // Swal.fire('Changes are not saved', '', 'info')
                            // }
                          })
                        }

                        // this.immediateList = response.data.return_data
                        // this.formData = response.data.return_data.form

                        // if(type == 1){
                        //   var todayForm = new Date();
                        //   var yearForm = todayForm.getFullYear();
                        //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                        //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                        //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                        //   todayForm = yearForm + monthForm + dateForm + timeForm;

                        //   this.formTitle = 'title_'+todayForm;
                        // } else {
                        //   this.formTitle = response.data.return_data.name;
                        // }

                        // this.showModal = true
                      } else {
                        let text = this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['update_not_success_default_swal_text'];
                        if(response.data.info != '' && response.data.info != null){
                          text = response.data.info
                        }
                        Swal.fire(
                          this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['update_not_success_swal_title'],
                          text,
                          'error'
                        )
                      }
                    });
                }

                if(caResponse.data.status == 'login'){
                  Swal.fire({
                    icon: 'error',
                    title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['login']['swal_title'],
                    text: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['login']['swal_text'],
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['login']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      // this.allPageLoading = true
                      window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      // this.allPageLoading = true
                      window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                    }
                  })
                }
              });
          }
        }
      },
      async customizeSave(status){
        console.log('customizeSave');
        console.log(status);

        let _tmpSubCampaignsContentLength = this.customRulesData.subCampaignsContent.length;
        let _stageData = [];
        let _tableData = [];
        const promises = [];

        for(let i = 0; i < _tmpSubCampaignsContentLength; i++){
          let isTrue = 1;
          let _swalTitle = '';
          let _swalText = '';
          let menuIndex = i + parseInt(1);
          let stageName = this.menu[menuIndex].title;

          console.log('customize stageName');
          console.log(stageName);

          // let onCheck = 1;
          // if(this.customRulesData.haveTest == true){
          //   if(this.customRulesData.subCampaignsContent[i].method == 'META_KW' || this.customRulesData.subCampaignsContent[i].method == 'META_LA' || this.customRulesData.subCampaignsContent[i].method == 'META_RT' || this.customRulesData.subCampaignsContent[i].method == 'META_ASC'){
          //     onCheck = 0;
          //   }
          // }

          // if(onCheck == 1){
          //   //有測試階段時，精準興趣、類似受眾、再行銷、ASC不用檢查目標、素材
          //   let _tmpCampaignObjective = this.customRulesData.subCampaignsContent[i].goalsData.campaign_objective;
          //   if(_tmpCampaignObjective == '' || _tmpCampaignObjective == null || typeof _tmpCampaignObjective == 'undefined'){
          //     isTrue = 0;

          //     _swalTitle = '自定義規則-'+stageName+'-目標';
          //     _swalText = '請勾選任一項目標。';
          //   }

          //   let _tmpSelectArticleLength = this.customRulesData.subCampaignsContent[i].postData.select_article.length;
          //   let _tmpSelectCreativesLength = this.customRulesData.subCampaignsContent[i].postData.select_creatives.length;
          //   let _tmpSelectCreativesAdsetAdsLength = this.customRulesData.subCampaignsContent[i].postData.select_creatives_adset_ads.length;
          //   let _tmpSelectCreativesAdsetAdsMessageLength = this.customRulesData.subCampaignsContent[i].postData.select_creatives_adset_ads_message.length;
          //   let _tmpSelectCreativesMessageLength = this.customRulesData.subCampaignsContent[i].postData.select_creatives_message.length;
          //   let _tmpCreativeArrayLength = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array.length;
          //   let dataLength = _tmpSelectArticleLength + _tmpSelectCreativesLength + _tmpSelectCreativesAdsetAdsLength + _tmpSelectCreativesAdsetAdsMessageLength + _tmpSelectCreativesMessageLength;

          //   if(_tmpCampaignObjective == 'LEAD_GENERATION' || _tmpCampaignObjective == 'MESSAGES'){
          //     dataLength = _tmpSelectArticleLength + _tmpSelectCreativesLength + _tmpSelectCreativesAdsetAdsLength + _tmpSelectCreativesAdsetAdsMessageLength + _tmpSelectCreativesMessageLength + _tmpCreativeArrayLength;
          //   }

          //   if(dataLength <= 0){
          //     isTrue = 0;

          //     _swalTitle = '自定義規則-'+stageName+'-素材';
          //     _swalText = '請至少設定一組素材。';
          //   }

          //   if(_tmpCampaignObjective == 'LEAD_GENERATION' || _tmpCampaignObjective == 'MESSAGES'){
          //     for(let k = 0; k < _tmpCreativeArrayLength; k++){

          //       let _tmpCreativeArrayTitle = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].title;
          //       if(_tmpCreativeArrayTitle == '' || _tmpCreativeArrayTitle == null || typeof _tmpCreativeArrayTitle == 'undefined'){
          //         isTrue = 0;

          //         _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
          //         _swalText = '每組廣告組合，都要輸入廣告名稱。';
          //       }

          //       let _tmpCreativeArrayType = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].type;
          //       if(_tmpCreativeArrayType == 2){
          //         let materials_length = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].materials.length

          //         if(materials_length < 2){
          //           materials_item = 1;
          //         } else {
          //           for(let j = 0; j < materials_length; j++){
          //             let _tmpCreativeArrayMaterialsObjectSpecId = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].materials[j].object_spec.id;
          //             if(_tmpCreativeArrayMaterialsObjectSpecId == '' || _tmpCreativeArrayMaterialsObjectSpecId == null || typeof _tmpCreativeArrayMaterialsObjectSpecId == 'undefined'){
          //               isTrue = 0;

          //               _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
          //               _swalText = '每組輪播卡片，都要選取素材。';
          //             }

          //             let _tmpCreativeArrayMaterialsTitle = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].materials[j].title;
          //             if(_tmpCreativeArrayMaterialsTitle == '' || _tmpCreativeArrayMaterialsTitle == null || typeof _tmpCreativeArrayMaterialsTitle == 'undefined'){
          //               isTrue = 0;

          //               _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
          //               _swalText = '每組輪播卡片，都要填寫標題。';
          //             }
          //           }
          //         }
          //       }

          //       if(_tmpCreativeArrayType == 1){
          //         let _tmpCreativeArrayMaterialSingleObjectSpecId = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].materialSingle[0].object_spec.id;
          //         if(_tmpCreativeArrayMaterialSingleObjectSpecId == '' || _tmpCreativeArrayMaterialSingleObjectSpecId == null || typeof _tmpCreativeArrayMaterialSingleObjectSpecId == 'undefined'){
          //           isTrue = 0;

          //           _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
          //           _swalText = '每組廣告組合，都要選取素材。';
          //         }

          //         let _tmpCreativeArrayMaterialSingleTitle = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].materialSingle[0].title;
          //         if(_tmpCreativeArrayMaterialSingleTitle == '' || _tmpCreativeArrayMaterialSingleTitle == null || typeof _tmpCreativeArrayMaterialSingleTitle == 'undefined'){
          //           isTrue = 0;

          //           _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
          //           _swalText = '每組廣告組合，都要填寫標題。';
          //         }
          //       }

          //       let _tmpCreativeArrayMessage = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].message;
          //       if(_tmpCreativeArrayMessage == '' || _tmpCreativeArrayMessage == null || typeof _tmpCreativeArrayMessage == 'undefined'){
          //         isTrue = 0;

          //         _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
          //         _swalText = '每組廣告組合，都要填寫主要文字。';
          //       }

          //       let _tmpCreativeArrayFormSrI = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].form_sr_i;
          //       if(_tmpCampaignObjective == 'LEAD_GENERATION' && (_tmpCreativeArrayFormSrI == '' || _tmpCreativeArrayFormSrI == null || typeof _tmpCreativeArrayFormSrI == 'undefined')){
          //         isTrue = 0;

          //         _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
          //         _swalText = '每組廣告組合，都要選取相對應的即時表單。';
          //       }

          //       let _tmpCreativeArrayMessageSrI = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].message_sr_i;
          //       if(_tmpCampaignObjective == 'MESSAGES' && (_tmpCreativeArrayMessageSrI == '' || _tmpCreativeArrayMessageSrI == null || typeof _tmpCreativeArrayMessageSrI == 'undefined')){
          //         isTrue = 0;

          //         _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
          //         _swalText = '每組廣告組合，都要選取相對應的訊息範本。';
          //       }

          //       if(isTrue == 0){
          //         break;
          //       }
          //     }
          //   }
          // }

          let _tmpCampaignAmount = this.customRulesData.subCampaignsContent[i].budgetExtraData.amount;
          let _tmpCampaignBudgetExtraList = this.customRulesData.subCampaignsContent[i].budgetExtraData.budget_extra_list;
          let _tmpCampaignFrequency = this.customRulesData.subCampaignsContent[i].budgetExtraData.frequency;

          console.log('_tmpCampaignAmount');
          console.log(_tmpCampaignAmount);
          console.log('_tmpCampaignBudgetExtraList');
          console.log(_tmpCampaignBudgetExtraList);
          console.log('_tmpCampaignFrequency');
          console.log(_tmpCampaignFrequency);

          // if ((_tmpCampaignAmount != 0 && _tmpCampaignAmount != '' && _tmpCampaignAmount != null) || (_tmpCampaignBudgetExtraList[0].num != 0 && _tmpCampaignBudgetExtraList[0].num != '' && _tmpCampaignBudgetExtraList[0].num != null) || (_tmpCampaignFrequency != 0 && _tmpCampaignFrequency != '' && _tmpCampaignFrequency != null)) {
          //   // 如果至少一個有填寫，檢查另外兩個是否都有填寫
          //   if ((_tmpCampaignAmount == 0 || _tmpCampaignAmount == '' || _tmpCampaignAmount == null) || (_tmpCampaignBudgetExtraList[0].num == 0 || _tmpCampaignBudgetExtraList[0].num == '' || _tmpCampaignBudgetExtraList[0].num == null) || (_tmpCampaignFrequency == 0 || _tmpCampaignFrequency == '' || _tmpCampaignFrequency == null)) {
          //     isTrue = 0;
          //     _swalTitle = '自定義規則-'+stageName+'-預算加碼';
          //     _swalText = '若要設定，請同時設定好金額、次數、CPA特定數值';
          //   }
          // }

          // let _tmpCampaignPageIdLength = this.customRulesData.subCampaignsContent[i].pdData.page_id;

          // if(_tmpCampaignPageIdLength == '' || _tmpCampaignPageIdLength == null || typeof _tmpCampaignPageIdLength == 'undefined'){
          //   isTrue = 0;

          //   _swalTitle = '自定義規則-'+stageName+'-Facebook';
          //   _swalText = '請選擇Facebook。';
          // }

          // let _tmpCampaignPublisherPlatformsLength = this.customRulesData.subCampaignsContent[i].pdData.publisher_platforms.length;

          // if(_tmpCampaignPublisherPlatformsLength <= 0){
          //   isTrue = 0;

          //   _swalTitle = '自定義規則-'+stageName+'-版位與裝置';
          //   _swalText = '請至少設定一個平台。';
          // }

          // let _tmpCampaignDevicePlatformsLength = this.customRulesData.subCampaignsContent[i].pdData.device_platforms.length;

          // if(_tmpCampaignDevicePlatformsLength <= 0){
          //   isTrue = 0;

          //   _swalTitle = '自定義規則-'+stageName+'-版位與裝置';
          //   _swalText = '請至少設定一個裝置。';
          // }

          // let _tmpCampaignCustomExcludedAudiencesSelectedLength = this.customRulesData.subCampaignsContent[i].exAudiencesData.custom_excluded_audiences_selected.length;
          // let _tmpCampaignDefaultExcludedAudiencesLength = this.customRulesData.subCampaignsContent[i].exAudiencesData.default_excluded_audiences.length;

          // let default_excluded_audiences_num = 0;
          // if(_tmpCampaignDefaultExcludedAudiencesLength > 0){
          //   for (var e = 0; e < _tmpCampaignDefaultExcludedAudiencesLength; e++) {
          //     if(this.customRulesData.subCampaignsContent[i].exAudiencesData.default_excluded_audiences[e].checked == true){
          //       default_excluded_audiences_num = parseInt(default_excluded_audiences_num) + parseInt(1);
          //     }
          //   }
          // }

          // let excluded_audiences_num = parseInt(_tmpCampaignCustomExcludedAudiencesSelectedLength) + parseInt(default_excluded_audiences_num);

          // if(excluded_audiences_num > 10){
          //   isTrue = 0;

          //   _swalTitle = '自定義規則-'+stageName+'-關系鏈與受眾';
          //   _swalText = '最多只能設定 10 個。';
          // }

          // let _tmpCampaignLocationsLength = this.customRulesData.subCampaignsContent[i].localData.locations.length;
          // let _tmpCampaignLocationRangeLength = this.customRulesData.subCampaignsContent[i].localData.location_range.length;

          // if((_tmpCampaignLocationsLength == 0 || _tmpCampaignLocationsLength == '' || _tmpCampaignLocationsLength == null || typeof _tmpCampaignLocationsLength == 'undefined') && (_tmpCampaignLocationRangeLength == 0 || _tmpCampaignLocationRangeLength == '' || _tmpCampaignLocationRangeLength == null || typeof _tmpCampaignLocationRangeLength == 'undefined')){
          //   isTrue = 0;

          //   _swalTitle = '自定義規則-'+stageName+'-地點';
          //   _swalText = '請至少設定一個地點。';
          // }

          let _tmpCampaignRuleStopLength = this.customRulesData.subCampaignsContent[i].stopData.rule_stop.length;
          for(let f = 0; f < _tmpCampaignRuleStopLength; f++){
            let shopValue = this.customRulesData.subCampaignsContent[i].stopData.rule_stop[f].num;
            if(shopValue == 0 || shopValue == '' || shopValue == null || typeof shopValue == 'undefined'){
              isTrue = 0;

              _swalTitle = '自定義規則-'+stageName+'-暫停條件';
              _swalText = '請每個規則條件都必須填寫值。';
            }
          }

          let _tmpCampaignRuleFrequencyLength = this.customRulesData.subCampaignsContent[i].forwardData.rule_frequency.length;
          let checkIndex = _tmpSubCampaignsContentLength - parseInt(1);

          if(checkIndex != i){
            for(let f = 0; f < _tmpCampaignRuleFrequencyLength; f++){
              let frequencyValue = this.customRulesData.subCampaignsContent[i].forwardData.rule_frequency[f].num;
              if(frequencyValue == 0 || frequencyValue == '' || frequencyValue == null || typeof frequencyValue == 'undefined'){
                isTrue = 0;

                _swalTitle = '自定義規則-'+stageName+'-前進規則';
                _swalText = '請每個規則條件都必須填寫值。';
              }
            }
          }

          // let _tmpCampaignEffect = this.customRulesData.subCampaignsContent[i].budgetData.effect;
          // if(_tmpCampaignEffect == 0 || _tmpCampaignEffect == '' || _tmpCampaignEffect == null || typeof _tmpCampaignEffect == 'undefined'){
          //   isTrue = 0;

          //   _swalTitle = '自定義規則-'+stageName+'-目標成本';
          //   _swalText = '請填寫目標成本。';
          // }

          // let _tmpCampaignDailyBudget = this.customRulesData.subCampaignsContent[i].budgetData.daily_budget;
          // console.log('_tmpCampaignDailyBudget');
          // console.log(_tmpCampaignDailyBudget);
          // if(_tmpCampaignDailyBudget == 0 || _tmpCampaignDailyBudget == '' || _tmpCampaignDailyBudget == null || typeof _tmpCampaignDailyBudget == 'undefined'){
          //   isTrue = 0;

          //   _swalTitle = '自定義規則-'+stageName+'-預算';
          //   _swalText = '請填寫預算。';
          // }

          // if(this.customRulesData.subCampaignsContent[i].method == 'META_KW'){
          //   let _tmpKeywordLength = this.customRulesData.subCampaignsContent[i].keywordData.keywords.length;
          //   let select_keywords_num = 0;

          //   for (let g = 0; g < _tmpKeywordLength; g++) {
          //     if(this.customRulesData.subCampaignsContent[i].keywordData.keywords[g].checked == true){
          //       select_keywords_num = parseInt(select_keywords_num) + parseInt(1);
          //     }
          //   }

          //   if(select_keywords_num != 5){
          //     isTrue = 0;

          //     _swalTitle = '自定義規則-'+stageName+'-精準興趣廣告組合與關鍵字';
          //     _swalText = '關鍵字需選擇 5 個。';
          //   }
          // }

          // if(this.customRulesData.subCampaignsContent[i].method == 'META_LA'){
          //   let _tmpDefaultLookalikesListLength = this.customRulesData.subCampaignsContent[i].lookData.default_lookalikes_list.length;
          //   let lookalikes_num = 0;
          //   if(_tmpDefaultLookalikesListLength > 0){
          //     for (let l = 0; l < _tmpDefaultLookalikesListLength; l++) {
          //       // console.log('i1:'+i);
          //       if(this.customRulesData.subCampaignsContent[i].lookData.default_lookalikes_list[l].checked == true){
          //         lookalikes_num = parseInt(lookalikes_num) + parseInt(1);
          //       }
          //     }
          //   }

          //   let _tmpCustomLookalikesSelectedLength = this.customRulesData.subCampaignsContent[i].lookData.custom_lookalikes_selected.length;
          //   if(_tmpCustomLookalikesSelectedLength > 0){
          //     for (let l = 0; l < _tmpCustomLookalikesSelectedLength; l++) {
          //       // console.log('i2:'+i);
          //       lookalikes_num = parseInt(lookalikes_num) + parseInt(1);
          //     }
          //   }

          //   if(lookalikes_num != 5){
          //     isTrue = 0;

          //     _swalTitle = '自定義規則-'+stageName+'-類似受眾廣告組合網址';
          //     _swalText = '類似受眾需選擇 5 個。';
          //   }
          // }

          // if(this.customRulesData.subCampaignsContent[i].method == 'META_RT'){
          //   let _tmpDefaultAudiencesListLength = this.customRulesData.subCampaignsContent[i].audiencesData.default_audiences_list.length;
          //   let audiences_num = 0;
          //   if(_tmpDefaultAudiencesListLength > 0){
          //     for (let r = 0; r < _tmpDefaultAudiencesListLength; r++) {
          //       // console.log('i1:'+i);
          //       if(this.customRulesData.subCampaignsContent[i].audiencesData.default_audiences_list[r].checked == true){
          //         audiences_num = parseInt(audiences_num) + parseInt(1);
          //       }
          //     }
          //   }

          //   let _tmpCustomAudiencesSelectedLength = this.customRulesData.subCampaignsContent[i].audiencesData.custom_audiences_selected.length;
          //   if(_tmpCustomAudiencesSelectedLength > 0){
          //     for (let r = 0; r < _tmpCustomAudiencesSelectedLength; r++) {
          //       // console.log('i2:'+i);
          //       audiences_num = parseInt(audiences_num) + parseInt(1);
          //     }
          //   }

          //   if(audiences_num < 1){
          //     isTrue = 0;

          //     _swalTitle = '自定義規則-'+stageName+'-再行銷廣告組合';
          //     _swalText = '請至少選擇 1 個再行銷受眾。';
          //   }
          // }

          console.log('isTrue');
          console.log(isTrue);

          if(isTrue == 1){
            let _tmpFormData = [];

            if(this.customRulesData.subCampaignsContent[i].method == 'META_TEST' && this.customRulesData.haveTest == true){
              // _tmpFormData['PreStage'] = [];
              _tmpFormData['ThisStage'] = this.customRulesData.subCampaignsContent[i];
            } else {
              let PreIndex = i - parseInt(1);
              // _tmpFormData['PreStage'] = this.customRulesData.subCampaignsContent[PreIndex];
              _tmpFormData['ThisStage'] = this.customRulesData.subCampaignsContent[i];
            }

            const promise = axios.post('https://test.autoturn.net/inside/api/data/campaign_subset_update_for_customize.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.$route.params.adaccount_id,
              date: this.dateData,
              stage: i,
              useDoForward: this.doForwardData.useDoForward,
              sub_length: _tmpSubCampaignsContentLength,
              haveTest: this.customRulesData.haveTest,
              campaign_id: this.campaign_id,
              form_data: _tmpFormData,
              useFixedTemp: true,
            }))
            .then((response) => {
              if (response.data.status === 'success') {
                console.log('campaign_subset_update_for_customize response');
                console.log(response);

                // 正确更新 stageData 和 _campaign_writing_status
                // Vue.set(this.customRulesData.subCampaignsContent[i].release, 'sr_i', parseInt(response.data.campaign_id));
                this.customRulesData.subCampaignsContent[i].release.sr_i = parseInt(response.data.campaign_id);

                if (response.data.campaign_id) {
                  _stageData[i] = parseInt(response.data.campaign_id);
                }
              }
            })
            .catch((error) => {
              console.error(`Error in form_update stage ${i}:`, error);
            });

            promises.push(promise); // 將 promise 加入數組
          } else {
            Swal.fire(
              _swalTitle,
              _swalText,
              "error"
            );

            break;
          }
        }

        await Promise.all(promises);

        console.log('All axios requests finished');
        console.log(_stageData);
        console.log(_stageData.length + '==' + _tmpSubCampaignsContentLength);

        // 在所有 axios 完成后，再执行以下逻辑
        if(_stageData.length == _tmpSubCampaignsContentLength){
          console.log('Promise.all');

          let adaccount_id = this.adaccount_id;
          let member_hash = this.$route.params.id;

          Swal.fire({
            icon: 'success',
            title: '行銷活動瀏覽/編輯頁 - 自定義編輯',
            text: '修改完畢，5 秒後將幫您導回列表頁。',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: 'OK',
            timer: 5000
            // denyButtonText: `Don't save`,
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              // Swal.fire('Saved!', '', 'success')
              this.allPageLoading = true
              window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
            } else if (result.isDenied) {
              // Swal.fire('Changes are not saved', '', 'info')
              this.allPageLoading = true
              window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
            }

            if (result.dismiss === Swal.DismissReason.timer) {
              this.allPageLoading = true
              window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
            }
          });
          // var daily_keyword_split_budget = this.methodData.Budget_KW;
          // var daily_demo_budget = this.methodData.Budget_DM;
          // var budget_addition = this.goalsData.form_addition;

          // this.total_budget = 0;

          // let _tmp_goalsData = this.goalsData;
          // const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
          // let _tmp_exAudiencesData = this.exAudiencesData;
          // const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

          // // console.log(_tmp_exAudiencesData);

          // delete _view_goalsData['objective_list'];
          // delete _view_exAudiencesData['custom_excluded_audiences'];

          // let formData = {
          //   campaign_id: this.campaign_id,
          //   campaign_name: this.campaign_name,
          //   adaccount_id: this.adaccount_id,
          //   Budget_KW_result: this.Budget_KW_result,
          //   total_budget: this.total_budget,
          //   dynBudgetData: this.dynBudgetData,
          //   doForwardData: this.doForwardData,
          //   methodData: this.methodData,
          //   dateData: this.dateData,
          //   keywordData: this.keywordData,
          //   lookData: this.lookData,
          //   audiencesData: this.audiencesData,
          //   goalsData: _view_goalsData,
          //   regionsData: this.regionsData,
          //   selectCountries: this.selectCountries,
          //   selectLangs: this.selectLangs,
          //   exAudiencesData: _view_exAudiencesData,
          //   pdData: this.pdData,
          //   idData: this.idData,
          //   postData: this.postData,
          //   adMaterialData: this.adMaterialDataNew,
          //   stageData: _stageData
          // }

          // console.log('warning formData');
          // console.log(formData);

          // let adaccount_id = this.adaccount_id

          // axios
          //   .post('https://test.autoturn.net/inside/api/data/campaign_update_v01.php', Qs.stringify({
          //     s_code: this.$route.params.id,
          //     form_data: formData,
          //     type: 'release',
          //     target: 'edit_release_'+this.target,
          //   }))
          //   .then((response) => {
          //     if(response.data.status == 'success'){
          //       if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
          //         let _tableContent = '<div class="table">\
          //                         <div class="row">\
          //                           <div class="cell header">階段</div>\
          //                           <div class="cell header">目標</div>\
          //                           <div class="cell header">預算</div>\
          //                         </div>';

          //         let _currency = this.currencyData.currency
          //         for(let j = 0; j < _tmpSubCampaignsContentLength; j++){
          //           let _methodName = this.methodName(this.customRulesData.subCampaignsContent[j].method);
          //           let _objectiveName = this.objectiveName(this.customRulesData.subCampaignsContent[j].goalsData.campaign_objective);
          //           let _budget = '<b>'+this.customRulesData.subCampaignsContent[j].budgetData.daily_budget+'</b><span style="font-size:14px; margin-left:4px; margin-top:4px;">'+_currency+'/day</span>';

          //           _tableContent += '<div class="row">\
          //                               <div class="cell">'+_methodName+'</div>\
          //                               <div class="cell">'+_objectiveName+'</div>\
          //                               <div class="cell">'+_budget+'</div>\
          //                             </div>';
          //         }

          //         _tableContent += '</div>';
          //         _tableContent += "<b style='color:red;'>請勿在Facebook廣告後台修改行銷活動設定、受眾資料(AutoTurn開頭)，<br/>若修改到系統便會暫停自動化</b><br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_c'];

          //         Swal.fire({
          //           title: '自定義規則 - 發布',
          //           html: _tableContent,
          //           icon: 'warning',
          //           showCancelButton: true,
          //           confirmButtonColor: '#3085d6',
          //           cancelButtonColor: '#d33',
          //           width: 'auto', // 可選：根據內容自動調整寬度
          //           padding: '1em',
          //           confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['yes_button'],
          //           cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['no_button'],
          //         }).then((result) => {
          //           if (result.isConfirmed) {
          //             this.releaseType = true
          //             this.style = 'z-index:100;';
          //             this.releasePercent = 5;
          //             let status = 1;
          //             let num = 0;
          //             let member_hash = this.$route.params.id;
          //             var bar5 = new ldBar("#myItem5");
          //             bar5.set(this.releasePercent);

          //             axios
          //               .post('https://test.autoturn.net/inside/api/campaign_release.php', Qs.stringify({
          //                 s_code: member_hash,
          //                 campaign_id: this.campaign_id,
          //               }))
          //               .then((caResponse) => {
          //                 // console.log('caResponse:'+caResponse.data.return_data);
          //                 if(caResponse.data.status == 'success'){
          //                   // console.log('#20');
          //                   //進行進度條
          //                   // console.log('發佈莞成，開始跑進度條');
          //                   setInterval( () => {
          //                     num++;
          //                     if(num < 1200){
          //                       // console.log('num:'+num);
          //                       // console.log(this.releaseType);

          //                       if(this.releaseType == true){
          //                         axios
          //                           .post('https://test.autoturn.net/inside/api/campaign_states.php', Qs.stringify({
          //                             s_code: member_hash,
          //                             adaccount_id: this.adaccount_id,
          //                             campaign_id: this.campaign_id,
          //                           }))
          //                           .then((csResponse) => {
          //                             // console.log('csResponse:'+csResponse.data.return_data);
          //                             //進行進度條
          //                             if(status == 1){
          //                               if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
          //                                 this.releaseType = false
          //                                 this.style = 'z-index:-1;';
          //                                 bar5.set(0);
          //                                 status = 0;
          //                                 // Swal.fire({
          //                                 //   icon: 'error',
          //                                 //   title: '正式發佈',
          //                                 //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
          //                                 //   showDenyButton: false,
          //                                 //   showCancelButton: false,
          //                                 //   confirmButtonText: '確定',
          //                                 //   timer: 5000
          //                                 //   // denyButtonText: `Don't save`,
          //                                 // }).then((result) => {
          //                                 //   /* Read more about isConfirmed, isDenied below */
          //                                 //   if (result.isConfirmed) {
          //                                 //     // Swal.fire('Saved!', '', 'success')
          //                                 //     this.allPageLoading = true
          //                                 //     window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
          //                                 //   } else if (result.isDenied) {
          //                                 //     // Swal.fire('Changes are not saved', '', 'info')
          //                                 //     this.allPageLoading = true
          //                                 //     window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
          //                                 //   }

          //                                 //   if (result.dismiss === Swal.DismissReason.timer) {
          //                                 //     this.allPageLoading = true
          //                                 //     window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
          //                                 //   }
          //                                 // })
          //                                 Swal.fire({
          //                                   icon: 'error',
          //                                   title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
          //                                   text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
          //                                   showDenyButton: false,
          //                                   showCancelButton: false,
          //                                   confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
          //                                 }).then((result) => {
          //                                   console.log('#1');
          //                                   let info_text = csResponse.data.return_data.info_text;
          //                                   let tosStatus = info_text.includes("/leadgen/tos");
          //                                   if(tosStatus == true){
          //                                     window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
          //                                   }
          //                                 })
          //                               } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
          //                                 status = 0;

          //                                 axios
          //                                   .post('https://test.autoturn.net/inside/api/data/campaign_creative_optimize_update.php', Qs.stringify({
          //                                     s_code: member_hash,
          //                                     id: this.campaign_id,
          //                                   }))
          //                                   .then((response) => {
          //                                     axios
          //                                       .get('https://test.autoturn.net/inside/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.campaign_id)
          //                                       .then((csResponse) => {
          //                                         this.releaseType = false

          //                                         Swal.fire({
          //                                           icon: 'success',
          //                                           title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
          //                                           text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
          //                                           showDenyButton: false,
          //                                           showCancelButton: false,
          //                                           confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
          //                                           timer: 5000
          //                                           // denyButtonText: `Don't save`,
          //                                         }).then((result) => {
          //                                           /* Read more about isConfirmed, isDenied below */
          //                                           if (result.isConfirmed) {
          //                                             // Swal.fire('Saved!', '', 'success')
          //                                             this.allPageLoading = true
          //                                             window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
          //                                           } else if (result.isDenied) {
          //                                             // Swal.fire('Changes are not saved', '', 'info')
          //                                             this.allPageLoading = true
          //                                             window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
          //                                           }

          //                                           if (result.dismiss === Swal.DismissReason.timer) {
          //                                             this.allPageLoading = true
          //                                             window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
          //                                           }
          //                                         })
          //                                       });
          //                                   });
          //                               } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
          //                                 this.releaseType = false
          //                                 this.style = 'z-index:-1;';
          //                                 bar5.set(0);
          //                                 status = 0;
          //                                 // Swal.fire({
          //                                 //   icon: 'error',
          //                                 //   title: '正式發佈',
          //                                 //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
          //                                 //   showDenyButton: false,
          //                                 //   showCancelButton: false,
          //                                 //   confirmButtonText: '確定',
          //                                 //   timer: 5000
          //                                 //   // denyButtonText: `Don't save`,
          //                                 // }).then((result) => {
          //                                 //   /* Read more about isConfirmed, isDenied below */
          //                                 //   if (result.isConfirmed) {
          //                                 //     // Swal.fire('Saved!', '', 'success')
          //                                 //     this.allPageLoading = true
          //                                 //     window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
          //                                 //   } else if (result.isDenied) {
          //                                 //     // Swal.fire('Changes are not saved', '', 'info')
          //                                 //     this.allPageLoading = true
          //                                 //     window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
          //                                 //   }

          //                                 //   if (result.dismiss === Swal.DismissReason.timer) {
          //                                 //     this.allPageLoading = true
          //                                 //     window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
          //                                 //   }
          //                                 // })
          //                                 Swal.fire({
          //                                   icon: 'error',
          //                                   title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
          //                                   text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
          //                                   showDenyButton: false,
          //                                   showCancelButton: false,
          //                                   confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
          //                                 }).then((result) => {
          //                                   console.log('#2');
          //                                   let info_text = csResponse.data.return_data.info_text;
          //                                   let tosStatus = info_text.includes("/leadgen/tos");
          //                                   if(tosStatus == true){
          //                                     window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
          //                                   }
          //                                 })
          //                               } else {
          //                                 this.releaseText = csResponse.data.return_data.info_text
          //                                 this.releasePercent = csResponse.data.return_data.info_pct

          //                                 bar5.set(this.releasePercent);
          //                                 // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
          //                                 // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
          //                                 // console.log('this.releaseText:'+this.releaseText);
          //                                 // console.log('this.releasePercent:'+this.releasePercent);

          //                                 if(csResponse.data.return_data.info_pct == 100){
          //                                   this.releaseType = false
          //                                   this.style = 'z-index:-1;';
          //                                   bar5.set(0);
          //                                   status = 0;
          //                                 }
          //                               }
          //                             }
          //                           });
          //                       }
          //                     } else {
          //                       Swal.fire({
          //                         icon: 'warning',
          //                         title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['swal_title'],
          //                         text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['swal_html'],
          //                         showDenyButton: false,
          //                         showCancelButton: false,
          //                         confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['confirm_button'],
          //                         timer: 1000
          //                         // denyButtonText: `Don't save`,
          //                       }).then((result) => {
          //                         /* Read more about isConfirmed, isDenied below */
          //                         if (result.isConfirmed) {
          //                           // Swal.fire('Saved!', '', 'success')
          //                           this.allPageLoading = true
          //                           window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
          //                         } else if (result.isDenied) {
          //                           // Swal.fire('Changes are not saved', '', 'info')
          //                           this.allPageLoading = true
          //                           window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
          //                         }

          //                         if (result.dismiss === Swal.DismissReason.timer) {
          //                           this.allPageLoading = true
          //                           window.location.href = "https://dev-private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
          //                         }
          //                       })
          //                     }
          //                   }, 3000);
          //                 }
          //               });
          //           }
          //         });
          //       } else {
          //         Swal.fire(
          //           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['not_success']['swal_title'],
          //           response.data.info,
          //           'error'
          //         )
          //       }

          //     } else {
          //       let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_default_swal_text'];
          //       if(response.data.info != '' && response.data.info != null){
          //         text = response.data.info
          //       }
          //       Swal.fire(
          //         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_swal_title'],
          //         text,
          //         'error'
          //       )
          //     }
          //   });

        } else {
          Swal.fire({
                      icon: 'error',
                      title: '自定義規則-確認修改',
                      html: '資料更新失敗，請稍候再嘗試。',
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: 'OK',
                    });

          console.log('error');
        }

        console.log('customize end');
        console.log(this.customRulesData);
      },
    },
    mounted () {
      // document.title = '行銷活動瀏覽/編輯頁 - AutoTurn';
    }
  }
</script>

<style lang="scss" scope>
  .progressbar {
    background: linear-gradient(270.01deg, #1D619F 0%, #7FDCFA 51.04%, #7AD5C0 76.56%);
    border-radius: 6px;
  }
</style>